export default {
  我的商品测量结果menu: '我的商品测量结果',
  我的商品测量结果: '我的商品测量结果（摄影&尺寸结果）',
  实物图片: '实物图片',
  简易检品: '简易检品',
  详细检品: '详细检品',
  开扣眼: '开扣眼',
  缝布标: '缝布标',
  缝水洗标: '缝水洗标',
  '去原标（水洗标、布标、吊牌）': '去原标（水洗标、布标、吊牌）',
  首饰台纸: '首饰台纸',
  检针服务: '检针服务',
  熨烫: '熨烫',
  除味: '除味',
  '感谢卡（检品时放在每件商品内）': '感谢卡（检品时放在每件商品内）',
  '丝带包装（检品时放在每件商品内）': '丝带包装（检品时放在每件商品内）',
  '雪梨纸包装（检品时放在每件商品内）': '雪梨纸包装（检品时放在每件商品内）',
  穿吊牌: '穿吊牌',
  通电检查: '通电检查',
  '刮刮卡（检品时放在每件商品内）': '刮刮卡（检品时放在每件商品内）',
  '优惠券（检品时放在每件商品内）': '优惠券（检品时放在每件商品内）',
  '保证卡（检品时放在每件商品内）': '保证卡（检品时放在每件商品内）',
  说明书: '说明书',
  普通OPP袋: '普通OPP袋',
  定制OPP袋: '定制OPP袋',
  特殊收纳袋: '特殊收纳袋',
  '其他物料放置（检品时放在每件商品内）':
    '其他物料放置（检品时放在每件商品内）',
  尺寸测量服务: '尺寸测量服务',
  气泡膜: '气泡膜',
  商品缠绕膜服务: '商品缠绕膜服务',
  商品缓冲垫服务: '商品缓冲垫服务',
  剪原标: '剪原标',
  剪布标: '剪布标',
  剪水洗标: '剪水洗标',
  剪吊牌: '剪吊牌',
  '尺寸变更(缝尺码标)': '尺寸变更(缝尺码标)',
  '尺寸变更(尺码贴)': '尺寸变更(尺码贴)',
  宽松检品: '宽松检品',
  圧縮袋梱包: '圧縮袋梱包',
  新商品服务: '新商品服务',
  '感谢卡（发货时放在每个包裹里）': '感谢卡（发货时放在每个包裹里）',
  '丝带包装（发货时放在每个包裹里）': '丝带包装（发货时放在每个包裹里）',
  装箱服务: '装箱服务',
  贴标: '贴标',
  打托盘: '打托盘',
  '雪梨纸包装（发货时放在每个包裹里）': '雪梨纸包装（发货时放在每个包裹里）',
  '刮刮卡（发货时放在每个包裹里）': '刮刮卡（发货时放在每个包裹里）',
  '优惠券（发货时放在每个包裹里）': '优惠券（发货时放在每个包裹里）',
  '保证卡（发货时放在每个包裹里）': '保证卡（发货时放在每个包裹里）',
  '其他物料放置（发货时放在每个包裹里）':
    '其他物料放置（发货时放在每个包裹里）',
  '发货袋-普通快递袋': '发货袋-普通快递袋',
  商品打木架: '商品打木架',
  贴箱唛: '贴箱唛',
  组合返工: '组合返工',
  // 异常订单
  商品问题原因: '商品问题原因',
  商品数量: '商品数量',
  请选择处理方式: '请选择处理方式',
  只可选择一种: '只可选择一种',
  更换颜色: '更换颜色',
  取消商品: '取消商品',
  换个链接: '换个链接',
  平台商品SKU: '平台商品SKU',
  'THE CKB订单编号': 'THE CKB订单编号',
  申请售后时间: '申请售后时间',
  售后进度: '售后进度',
  售后原因: '售后原因',
  导出订单: '导出订单',
  重新发起: '重新发起',
  撤销: '撤销',
  申请售后: '申请售后',
  撤销售后: '撤销售后',
  申请时间: '申请时间',
  取消进度: '取消进度',
  '该操作，会将已发起售后商品信息撤销，请确认是否撤销该商品售后？':
    '该操作，会将已发起售后商品信息撤销，请确认是否撤销该商品售后？',
  撤销商品不可再次发起撤销: '撤销商品不可再次发起撤销',
  请选择售后原因: '请选择售后原因',
  详细说明: '详细说明',
  申请售后数量: '申请售后数量',
  售后退款金额: '售后退款金额',
  '点击上传图片（最多上传5张）(只能上传jpg/png文件，且不超过10000kb)':
    '点击上传图片（最多上传5张）(只能上传jpg/png文件，且不超过10000kb)',
  撤销成功: '撤销成功',
  问题处理: '问题处理',
  问题处理2: '问题处理',
  售后: '售后',
  申请取消: '申请取消',
  商品取消履历: '商品取消履历',
  待处理: '待处理',
  业务处理中: '业务处理中',
  财务处理中: '财务处理中',
  已退款: '已退款',
  已拒绝: '已拒绝',
  已拒绝2: '已拒绝',
  '重新发起（处理中）': '重新发起（处理中）',
  已撤销: '已撤销',
  次品: '次品',
  次品2: '次品',
  相异品: '相异品',
  数量不足: '数量不足',
  处理中: '处理中',
  保留库存: '保留库存',
  取消成功: '取消成功',
  商品信息: '商品信息',
  '商品信息(CM)': '商品信息(CM)',
  问题生成时间: '问题生成时间',
  处理方式: '处理方式',
  取消数量: '取消数量',
  退款金额: '退款金额',
  申请售后件数: '申请售后件数',
  拒绝原因: '拒绝原因',
  拒绝原因2: '拒绝原因',
  退款总金额: '退款总金额',
  退款说明: '退款说明',
  不可优先发货: '不可优先发货',
  '可优先发货(订单下部分商品已全部上架)':
    '可优先发货(订单下部分商品已全部上架)',
  未处理: '未处理',
  已处理: '已处理',
  '商品与运输方式不匹配，THE CKB为您推荐了更合适的运输方式，需要您进行确认':
    '商品与运输方式不匹配，THE CKB为您推荐了更合适的运输方式，需要您进行确认',
  待确认运输方式: '待确认运输方式',
  原运输方式: '原运输方式',
  建议运输方式: '建议运输方式',
  使用新运输方式: '使用新运输方式',
  使用原运输方式: '使用原运输方式',
  按照建议运输方式发货: '按照建议运输方式发货',
  保持原运输方式发货: '保持原运输方式发货',
  整单确认: '整单确认',
  按SKU确认: '按SKU确认',
  '如果此单使用多种运输方式，提交后将会拆分成多个国际发货单子单':
    '如果此单使用多种运输方式，提交后将会拆分成多个国际发货单子单',
  此国际发货单已取消发货: '此国际发货单已取消发货',
  '成功，此国际发货单将按照建议运输方式发货':
    '成功，此国际发货单将按照建议运输方式发货',
  '成功，此国际发货单将保持原运输方式发货':
    '成功，此国际发货单将保持原运输方式发货',
  // 我的订单
  商品sku: '商品sku',
  组合附加项: '组合附加项',
  下单组合数: '下单组合数',
  组合完成数: '组合完成数',
  '服务费（元）': '服务费（元）',
  组合状态: '组合状态',
  商品画像: '商品画像',
  本单质检上架数: '本单质检上架数',
  转结落单库存数: '转结落单库存数',
  组合落单库存处理情况: '组合落单库存处理情况',
  国家: '国家',
  都道府県: '都道府県',
  序号: '序号',
  商品单价: '商品单价',
  '总价（RMB）': '总价（RMB）',
  商品状态: '商品状态',
  详情费用: '详情费用',
  代买手续费: '代买手续费',
  入库手续费: '入库手续费',
  质检手续费: '质检手续费',
  发货手续费: '发货手续费',
  发货单号: '发货单号',
  生成时间: '生成时间',
  国际运单号: '国际运单号',
  重量g: '重量g',
  是否发货: '是否发货',
  发货时间: '发货时间',
  商品番号: '商品番号',
  其他费用: '其他费用',
  费用类型: '费用类型',
  费用明细: '费用明细',
  时间: '时间',
  地址详情: '地址详情',
  客户订单编号: '客户订单编号',
  下单时间: '下单时间',
  详情地址: '详情地址',
  编辑地址: '编辑地址',
  取消并退款: '取消并退款',
  已上架: '已上架',
  检品中: '检品中',
  异常: '异常',
  国内运输中: '国内运输中',
  已发货: '已发货',
  已采购: '已采购',
  采购中: '采购中',
  已入库: '已入库',
  待采购: '待采购',
  查看: '查看',
  发货单详情: '发货单详情',
  未发货: '未发货',
  编辑收货地址: '编辑收货地址',
  费用详情: '费用详情',
  请确认取消信息: '请确认取消信息',
  '确认是否取消？': '确认是否取消？',
  合: '合',
  订单编号: '订单编号',
  等待审核: '等待审核',
  下单成功: '下单成功',
  订单来源: '订单来源',
  订单类型: '订单类型',
  国际物流信息详情: '国际物流信息详情',
  业务类型: '业务类型',
  取消结果: '取消结果',
  所有订单: '所有订单',
  待付款: '待付款',
  可发货: '可发货',
  部分发货: '部分发货',
  已完成: '已完成',
  已完成2: '支払完了',
  物流公司: '物流公司',
  国际物流单号: '国际物流单号',
  发货数量: '发货数量',
  是否合单: '是否合单',
  Base: 'Base',
  Shopify: 'Shopify',
  Stores: 'STORES',
  Amazon: 'Amazon',
  直发订单: '直发订单',
  囤货订单: '囤货订单',
  可优先发货: '可优先发货',
  未组合: '未组合',
  组合中: '组合中',
  组合完成: '组合完成',
  取消组合: '取消组合',
  日志: '日志',
  详情: '详情',
  优先发货: '优先发货',
  去支付: '去支付',
  是否去支付: '是否去支付',
  国际物流单号信息: '国际物流单号信息',
  商品日志详情: '商品日志详情',
  支付成功: '支付成功',
  结束时间: '结束时间',
  商品搜索: '商品搜索',
  下单日: '下单日',
  发货日: '发货日',
  客户商品信息: '客户商品信息',
  客户商品SKU: '客户商品SKU',
  客户商品名称: '客户商品名称',
  客户商品规格: '客户商品规格',
  客户商品图片: '客户商品图片',
  采购商品SKU: '采购商品SKU',
  采购商品信息: '采购商品信息',
  采购商品名称: '采购商品名称',
  采购商品规格: '采购商品规格',
  采购商品图片: '采购商品图片',
  商品采购渠道: '商品采购渠道',
  商品状态变更日志: '商品状态变更日志',
  操作记录: '操作记录',
  变更时间: '变更时间',
  '已上架（已清算）': '已上架（已清算）',

  // 授权店铺
  '你授权的xxx店铺取消授权后，店铺订单和商品将不再同步，是否继续取消？':
    '你授权的xxx店铺取消授权后，店铺订单和商品将不再同步，是否继续取消？',
  是: '是',
  否: '否',
  解绑成功: '解绑成功',
  店铺名: '店铺名',
  创建时间: '创建时间',
  状态: '状态',
  店铺钱包可用余额: '店铺钱包可用余额',
  店铺账号: '店铺账号',
  api权限: 'api权限',
  店铺管理: '店铺管理',
  授权店铺管理: '授权店铺管理',
  添加新店铺: '添加新店铺',
  激活子账号: '激活子账号',
  配置店铺: '配置店铺',
  开启自动同步下单: '开启自动同步下单',
  取消授权: '取消授权',
  创建成功: '创建成功',
  创建成功2: '创建成功',
  修改成功: '修改成功',
  物流配置修改成功: '物流配置修改成功',
  // 我的钱包
  水洗标制作: '水洗标制作',
  日本配送公司: '日本配送公司',
  国际发货单号: '国际发货单号',
  偏远地区附加费: '偏远地区附加费',
  '出账 / 入账': '出账 / 入账',
  余额: '余额',
  明细: '明细',
  流水号: '流水号',
  日期: '日期',
  可用余额: '可用余额',
  直行发货单号: '直行发货单号',
  出账: '出账',
  入账: '入账',
  充值: '充值',
  转账: '转账',
  表格导出: '表格导出',
  的钱包: '的钱包',
  主账号钱包: '主账号钱包',
  我的店铺钱包: '我的店铺钱包',
  冻结金额: '冻结金额',
  未入账金额: '未入账金额',
  查询: '查询',
  收据下载: '收据下载',
  银行名: '银行名',
  金额: '金额',
  币种: '币种',
  上传凭证: '上传凭证',
  '振込金額(日本円)': '振込金額(日本円)',
  公司名称: '公司名称',
  店铺主页入口: '店铺主页入口',
  姓氏: '姓氏',
  名字: '名字',
  邮箱地址: '邮箱地址',
  国际: '国际',
  存入金额: '存入金额',
  '加载完成！': '加载完成！',
  '充值成功！': '充值成功！',
  收款账号: '收款账号',
  最多可转账金额: '最多可转账金额',
  '商品sku/店铺商品sku/海外仓sku': '商品sku/店铺商品sku/海外仓sku',
  选择地址: '选择地址',
  输入的手机号位数不正确: '输入的手机号位数不正确',
  区町村不能为空: '区町村不能为空',
  最少3个文字以上: '最少3个文字以上',
  请输入正确的邮编: '请输入正确的邮编',
  地址添加成功: '地址添加成功',
  'sku/平台商品信息': 'sku/平台商品信息',
  库存数量: '库存数量',
  客户商品sku: '客户商品sku',
  海外仓sku: '海外仓sku',
  店铺名称: '店铺名称',
  需要填写清关地址: '需要填写清关地址',
  选择清关地址: '选择清关地址',
  添加清关地址: '添加清关地址',
  补货批次标题: '补货批次标题',
  箱唛上传: '箱唛上传',
  物流方式: '物流方式',
  kg: 'kg',
  计算: '计算',
  预估物流价: '预估物流价',
  '注意：您可以在此输入预计的重量 大致估算出物流价格，货品发出前将根据实际扣除物流费用，请确保您的账户余额充足，余额不足无法扣款将影响您的发货进度。':
    '注意：您可以在此输入预计的重量 大致估算出物流价格，货品发出前将根据实际扣除物流费用，请确保您的账户余额充足，余额不足无法扣款将影响您的发货进度。',
  填写: '填写',
  移除: '移除',
  请选择商品: '请选择商品',
  '区町村-详细地址': '区町村-详细地址',
  国际发货标题不能为空: '国际发货标题不能为空',
  必填: '必填',
  必填2: '必填',
  物流方式不能为空: '物流方式不能为空',
  保存成功: '保存成功',
  '文件大小不超过50m；支持格式doc;excel;pdf;':
    '文件大小不超过50m；支持格式doc;excel;pdf;',
  箱唛上传不能为空: '箱唛上传不能为空',
  拣货中: '拣货中',
  打标中: '打标中',
  打包中: '打包中',
  打包完成: '打包完成',
  标题: '标题',
  运单号: '运单号',
  大件fba: '大件fba',
  大件普通: '大件普通',
  小件: '小件',
  次品退货: '次品退货',
  异常退货: '异常退货',
  仓库调拨: '仓库调拨',
  创建补货计划: '创建补货计划',
  'Amazon sku': 'Amazon sku',
  sku: 'sku',
  补货批次号: '补货批次号',
  国际运费号: '国际运费号',
  运输方式: '运输方式',
  合计总额: '合计总额',
  AMAZON商品名称: 'AMAZON商品名称',
  计划发货数量: '计划发货数量',
  基本详情: '基本详情',
  发货重量: '发货重量',
  计费重量: '计费重量',
  国际发货状态: '国际发货状态',
  '收货仓/地址': '收货仓/地址',
  配送件数: '配送件数',
  箱数: '箱数',
  装箱清单: '装箱清单',
  装箱清单2: '装箱清单',
  商品内容: '商品内容',
  创建国际发货: '创建国际发货',
  // oem
  寻源表: '寻源表',
  寻源种类: '寻源种类',
  类别: '类别',
  X类: 'X类',
  类别注明: '类别注明',
  产品名称: '产品名称',
  参考图片: '参考图片',
  提供项: '提供项',
  是否提供: '是否提供',
  具体内容: '具体内容',
  参考链接: '参考链接',
  样衣: '样衣',
  物流单号: '物流单号',
  需要改动的地方: '需要改动的地方',
  '描述内容(材质，设计，颜色，尺寸等)': '描述内容(材质，设计，颜色，尺寸等)',
  附件: '附件',
  式样书: '式样书',
  '附件(包含产品的色卡、尺寸、特殊工艺、面料信息等)':
    '附件(包含产品的色卡、尺寸、特殊工艺、面料信息等)',
  面料: '面料',
  需求描述: '需求描述',
  面料信息: '面料信息',
  色卡信息: '色卡信息',
  Logo: 'Logo',
  '详细说明(颜色、尺寸、位置、工艺等)': '详细说明(颜色、尺寸、位置、工艺等)',
  辅料种类: '辅料种类',
  'THE CKB预选方案选择': 'THE CKB预选方案选择',
  分类: '分类',
  选择方案: '选择方案',
  定制补充部分: '定制补充部分',
  文字描述: '文字描述',
  材质方案: '材质方案',
  款式方案: '款式方案',
  尺寸方案: '尺寸方案',
  颜色方案: '颜色方案',
  款式描述: '款式描述',
  材质描述: '材质描述',
  尺寸描述: '尺寸描述',
  颜色描述: '颜色描述',
  设计图或参考图片: '设计图或参考图片',
  产品信息: '产品信息',
  具体尺码信息: '具体尺码信息',
  对应关系: '对应关系',
  自己提供: '自己提供',
  尺码表: '尺码表',
  参考链接尺寸: '参考链接尺寸',
  'THE CKB提供': 'THE CKB提供',
  其他补充: '其他补充',
  下单需求: '下单需求',
  期望价格: '期望价格',
  期望交期: '期望交期',
  期望起订量范围: '期望起订量范围',
  侧重点: '侧重点',
  品质: '品质',
  交期: '交期',
  Logo需求情况: 'Logo需求情况',
  需要: '需要',
  不需要: '不需要',
  '工厂、资质要求': '工厂、资质要求',
  特殊需求: '特殊需求',
  服装: '服装',
  杂货: '杂货',
  辅料: '辅料',
  内容: '内容',
  备注说明: '备注说明',
  操作人: '操作人',
  报价信息: '报价信息',
  是否加Logo: '是否加Logo',
  是否为特殊面料: '是否为特殊面料',
  次品处理方式: '次品处理方式',
  风险: '风险',
  打样费: '打样费',
  打样时间: '打样时间',
  天: '天',
  最小起订量: '最小起订量',
  单尺码: '单尺码',
  多尺码: '多尺码',
  商品数量区间: '商品数量区间',
  阶梯价格: '阶梯价格',
  报价有效期: '报价有效期',
  国际运费说明: '国际运费说明',
  全部订单: '全部订单',
  未发布: '未发布',
  等待报价: '等待报价',
  已报价: '已报价',
  寻源成功: '寻源成功',
  报价失效: '报价失效',
  已取消: '已取消',
  已取消2: '已取消',
  重新发布: '重新发布',
  再次买入单号: '再次买入单号',
  类型: '类型',
  申请表: '申请表',
  商品名: '商品名',
  查看明细: '查看明细',
  发起时间: '发起时间',
  寻源单编号: '寻源单编号',
  查看详情: '查看详情',
  拒绝备注: '拒绝备注',
  是否确认编辑: '是否确认编辑',
  是否确认发布寻源单: '是否确认发布寻源单',
  发布: '发布',
  是否确认取消待发布寻源单: '是否确认取消待发布寻源单',
  是否确定下样品单: '是否确定下样品单',
  下样品单: '下样品单',
  是否确定下大货单: '是否确定下大货单',
  下大货单: '下大货单',
  是否确认申请退款: '是否确认申请退款',
  申请退款: '申请退款',
  报价过期: '报价过期',
  是否确认申请复购: '是否确认申请复购',
  复购申请: '复购申请',
  是否确认重新编辑: '是否确认重新编辑',
  重新编辑: '重新编辑',
  重新编辑2: '重新编辑',
  操作日志: '操作日志',
  发布成功: '发布成功',
  退款成功: '退款成功',
  已提交申请复购: '已提交申请复购',
  复购申请中: '复购申请中',
  复购已拒绝: '复购已拒绝',
  复购已报价: '复购已报价',
  //
  未关联: '未关联',
  已关联: '已关联',
  关联异常: '关联异常',
  待关联: '待关联',
  售卖价格: '售卖价格',
  关联状态: '关联状态',
  已关联SKU数量: '已关联SKU数量',
  采购商品名: '采购商品名',
  采购价格: '采购价格',
  采购商品图: '采购商品图',
  创建关联商品: '创建关联商品',
  '该店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能。':
    '该店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能。',
  '因采购链接发生变动，请重新绑定': '因采购链接发生变动，请重新绑定',
  // 占行
  编辑关联: '编辑关联',
  番号保存成功: '番号保存成功',
  组合商品SKU: '组合商品SKU',
  组合在库状态: '组合在库状态',
  '单价（元）': '单价（元）',
  '待组合库存数量（截止时间）': '待组合库存数量（截止时间）',
  组合商品管理: '组合商品管理',
  扩大加购: '扩大加购',
  完结: '完结',
  加购: '加购',
  附加项修改成功: '附加项修改成功',
  添加成功: '添加成功',
  完结成功: '完结成功',
  存在待组合: '存在待组合',
  不存在待组合: '不存在待组合',
  找相似: '找相似',
  断开: '断开',
  店铺商品sku解绑成功: '店铺商品sku解绑成功',
  选定: '选定',
  已连接其他SKU: '已连接其他SKU',
  断开原有链接: '断开原有链接',
  请选择采购商品sku: '请选择采购商品sku',
  请选择店铺商品sku: '请选择店铺商品sku',
  请选择商品附加项: '请选择商品附加项',
  店铺商品sku绑定成功: '店铺商品sku绑定成功',
  '同步商品进行中，请等待1-3分钟': '同步商品进行中，请等待1-3分钟',
  同步成功: '同步成功',
  '10-20元': '10-20元',
  '20-30元': '20-30元',
  '30-50元': '30-50元',
  '50-100元': '50-100元',
  '100-150元': '100-150元',
  '200-300元': '200-300元',
  '300元以上': '300元以上',
  选择要链接的商品: '选择要链接的商品',
  选择要链接商品的SKU: '选择要链接商品的SKU',
  自动同步采购订单: '自动同步采购订单',
  '同步已授权的店铺内商品，并进行绑定': '同步已授权的店铺内商品，并进行绑定',
  //
  搜索青蛙商品: '搜索青蛙商品',
  商品链接或商品名: '商品链接或商品名',
  类目筛选: '类目筛选',
  价格筛选: '价格筛选',
  采购商品: '采购商品',
  店铺商品: '店铺商品',
  重新选择商品: '重新选择商品',
  创建关联: '创建关联',
  系统查询到您有辅料未添加到附加项配置: '系统查询到您有辅料未添加到附加项配置',
  平均单价: '平均单价',
  锁定: '锁定',
  可用: '可用',
  待处理次品: '待处理次品',
  辅料图片: '辅料图片',
  辅料名称: '辅料名称',
  关联附加项: '关联附加项',
  辅料规格: '辅料规格',
  辅料skuid: '辅料skuid',
  待入库: '待入库',
  次品图: '次品图',
  说明: '说明',
  丢弃: '丢弃',
  转为正常商品: '转为正常商品',
  我的商品库存: '我的商品库存',
  我的物料: '我的物料',
  未关联附加项: '未关联附加项',
  '未关联附加项的辅料，将不会再订单商品中自动使用':
    '未关联附加项的辅料，将不会再订单商品中自动使用',
  配置附加项: '配置附加项',
  辅料绑定提醒: '辅料绑定提醒',
  '物料名/sku': '物料名/sku',
  已有关联附加项: '已有关联附加项',
  未有关联附加项: '未有关联附加项',
  可用库存数量筛选: '可用库存数量筛选',
  至: '至',
  清空: '清空',
  批量加入购物车: '批量加入购物车',
  '关闭自动续费后，您的会员将于': '关闭自动续费后，您的会员将于',
  到期请前往paypal平台关闭自动续费: '到期请前往paypal平台关闭自动续费',
  '到期是否现在关闭？': '到期是否现在关闭？',
  '恭喜！！！已为您开启自动续费，记得保持余额充足':
    '恭喜！！！已为您开启自动续费，记得保持余额充足',
  支付方式: '支付方式',
  购买明细: '购买明细',
  会员信息: '会员信息',
  原价: '原价',
  优惠金额: '优惠金额',
  か月: 'か月',
  有效期: '有效期',
  总计: '总计',
  立即支付: '立即支付',
  立即支付2: '立即支付',
  '购买会员到期后我们会为您自动续费，您可在工作台-会员管理中关闭自动续费服务':
    '购买会员到期后我们会为您自动续费，您可在工作台-会员管理中关闭自动续费服务',
  月会员办理: '月会员办理',
  每月: '每月',
  选择办理会员周期: '选择办理会员周期',
  请联系主账号更改会员等级: '请联系主账号更改会员等级',
  去充值: '去充值',
  您的账户余额不足: '您的账户余额不足',
  确认支付: '确认支付',
  '立即购买（自动续费）': '立即购买（自动续费）',
  '购买后新会员等级立即生效，原有等级作废，如有疑问请联系客服':
    '购买后新会员等级立即生效，原有等级作废，如有疑问请联系客服',
  请选择会员套餐: '请选择会员套餐',
  自动续费中: '自动续费中',
  开通自动续费: '开通自动续费',
  到期: '到期',
  关闭成功: '关闭成功',
  // 我的消息
  我的消息: '我的消息',
  全部已读: '全部已读',
  已读: '已读',
  '未读/已读': '未读/已读',
  // 表单
  姓名: '姓名',
  请输入姓名: '请输入姓名',
  手机号: '手机号',
  请输入手机号: '请输入手机号',
  请输入市区町村: '请输入市区町村',
  请输入详细地址: '请输入详细地址',
  请输入邮编: '请输入邮编',
  请输入邮箱: '请输入邮箱',
  '你的子账号没有修改权限，请联系主账号管理者修改你的密码':
    '你的子账号没有修改权限，请联系主账号管理者修改你的密码',
  无效内容: '无效内容',
  无效的地址: '无效的地址',
  收件人姓名不能为空: '收件人姓名不能为空',
  市不能为空: '市不能为空',
  添加地址: '添加地址',
  // 确认框
  确定删除该商品: '确定删除该商品？',
  确定不再显示该商品: '确定不再显示该商品？',
  确定清空购物车: '确定清空购物车？',
  确定删除此配置: '确定删除此配置？',
  确定删除此地址: '确定删除此地址？',
  '当前页面的修改内容未保存，是否离开': '当前页面的修改内容未保存，是否离开？',
  // 消息框
  请至少选择一个配置类目: '请至少选择一个配置类目',
  请将收货人信息填写完整后提交订单: '请将收货人信息填写完整后提交订单',
  '单笔订单价值不得超过XX元，请调整商品数量':
    '单笔订单价值不得超过XX元，请调整商品数量',
  添加附加项模板成功: '添加附加项模板成功',
  修改附加项模板成功: '修改附加项模板成功',
  修改邮箱成功: '修改邮箱成功',
  // 登录
  登录: '登录',
  请登录: '请登录',
  请先登录: '请先登录',
  密码登录: '密码登录',
  邮箱验证登录: '邮箱验证登录',
  获取验证码: '获取验证码',
  忘记密码: '忘记密码',
  '没有账号?去注册会员': '没有账号?去注册会员',
  '用户名或邮箱不正确，请重新输入1-10位用户名或邮箱':
    '用户名或邮箱不正确，请重新输入1-10位用户名或邮箱',
  '输入的密码格式不正确，密码由6-20位字母或数字组成':
    '输入的密码格式不正确，密码由6-20位字母或数字组成',
  '邮箱格式不正确，请重新输入': '邮箱格式不正确，请重新输入',
  '验证码格式不正确，请重新输入': '验证码格式不正确，请重新输入',
  // 占行
  '验证码正在发送，请注意查收': '验证码正在发送，请注意查收',
  '密码不正确，请重新输入': '密码不正确，请重新输入',
  '用户名或密码不正确，请重新输入': '用户名或密码不正确，请重新输入',
  '邮箱或验证码错误，请重新输入': '邮箱或验证码错误，请重新输入',
  密码不能为空: '密码不能为空',
  用户名不能为空: '用户名不能为空',
  输入用户名: '输入用户名',
  输入密码: '输入密码',
  输入邮箱: '输入邮箱',
  输入验证码: '输入验证码',
  找回密码: '找回密码',
  重设密码: '重设密码',
  注册邮箱: '注册邮箱',
  邮箱验证码: '邮箱验证码',
  新密码设置: '新密码设置',
  再次确认新密码: '再次确认新密码',
  密码修改成功: '密码修改成功',
  '密码修改成功，请重新登录': '密码修改成功，请重新登录',
  提交: '提交',
  // 注册
  注册: '注册',
  免费注册: '免费注册',
  '已有会员，': '已有会员，',
  立即登录: '立即登录',
  请选择适合你的业务类型: '请选择适合你的业务类型',
  适合想要进货到日本仓库的用户: '适合想要进货到日本仓库的用户',
  适合想要从中国直发商品到末端客户的用户:
    '适合想要从中国直发商品到末端客户的用户',
  立即进入: '立即进入',
  用户名: '用户名',
  联系人姓名: '联系人姓名',
  密码: '密码',
  再次确认密码: '再次确认密码',
  性别: '性别',
  先生: '先生',
  女士: '女士',
  邮箱: '邮箱',
  验证码: '验证码',
  联系电话: '联系电话',
  已发送: '已发送',
  该用户名已被注册: '该用户名已被注册',
  '用户名不可用，请重新设置1-18位用户名不支持标点符号':
    '用户名不可用，请重新设置1-18位用户名不支持标点符号',
  '用户名不可用，请重新设置6-12位用户名不支持标点符号':
    '用户名不可用，请重新设置6-12位用户名不支持标点符号',
  联系人姓名不能为空: '联系人姓名不能为空',
  '格式不正确，请输入真实姓名，包括假名和文字及英文':
    '格式不正确，请输入真实姓名，包括假名和文字及英文',
  '输入的密码格式不正确，请设置6-32位字母或数字，区分大小写':
    '输入的密码格式不正确，请设置6-32位字母或数字，区分大小写',
  两次密码不一致: '两次密码不一致',
  邮箱已被注册: '邮箱已被注册',
  无效的手机号码: '无效的手机号码',
  请设置用户名: '请设置用户名',
  '你的名字是？': '你的名字是？',
  设置你的登陆密码: '设置你的登陆密码',
  请再次输入您的密码: '请再次输入您的密码',
  '请输入您的手机号码（选填）': '请输入您的手机号码（选填）',
  '请输入你的Chatwork ID （选填）': '请输入你的Chatwork ID （选填）',
  '请输入你的Skype （选填）': '请输入你的Skype （选填）',
  注册并登录: '注册并登录',
  同意以下条款: '同意以下条款',
  会员条约: '会员条约',
  默认业务类型: '默认业务类型',
  新密码: '新密码',
  原密码: '原密码',
  旧密码重置密码: '旧密码重置密码',
  邮箱重置密码: '邮箱重置密码',
  请输入原密码: '请输入原密码',
  请输入新密码: '请输入新密码',
  '已有账号，马上登录': '已有账号，马上登录',
  输入Aucfan的注册邮箱: '输入 Aucfan 的注册邮箱',
  输入Aucfan的注册邮箱提示:
    '请务必输入此项，我们会根据您输入的信息赠送免费会员试用',
  // 提现
  提现渠道: '提现渠道',
  银行名称: '银行名称',
  银行名称3: '银行名称',
  支店名: '支店名',
  口座类别: '口座类别',
  银行账号: '银行账号',
  银行账号3: '银行账号',
  收款人名称: '收款人名称',
  '提现金额（RMB）': '提现金额（RMB）',
  汇率: '汇率',
  费率: '费率',
  可提现金额: '可提现金额',
  提现手续费: '提现手续费',
  '提现金额（JPY）': '提现金额（JPY）',
  提现原因: '提现原因',
  电子邮件地址: '电子邮件地址',
  银行卡: '银行卡',
  普通: '普通',
  发送: '发送',
  请选择提现渠道: '请选择提现渠道',
  请输入银行名称: '请输入银行名称',
  请输入支店名: '请输入支店名',
  请选择口座类别: '请选择口座类别',
  请输入银行账号: '请输入银行账号',
  请输入收款人名称: '请输入收款人名称',
  请输入提现金额: '请输入提现金额',
  请输入验证码: '请输入验证码',
  请输入提现原因: '请输入提现原因',
  请输入邮箱验证码: '请输入邮箱验证码',
  // Bar
  个人中心: '个人中心',
  帮助: '帮助',
  历史订单: '历史订单',
  我的库存: '我的库存',
  用户信息: '用户信息',
  OEM寻源单: 'OEM寻源单',
  OEM发起寻源: 'OEM发起寻源',
  同步的订单: '同步的订单',
  插件安装: '插件安装',
  购买会员等级: '购买会员等级',
  我的店铺: '我的店铺',
  我的钱包: '我的钱包',
  登录账户管理: '登录账户管理',
  授权店铺: '授权店铺',
  异常订单: '异常订单',
  购物车: '购物车',
  搜索: '搜索',
  最近加入的商品: '最近加入的商品',
  选择你经常使用的功能: '选择你经常使用的功能',
  最多可选择X个: '最多可选择X个',
  请选择你经常使用的类目: '请选择你经常使用的类目',
  // 用户
  '欢迎来到THE CKB': '欢迎来到THE CKB',
  会员等级: '会员等级',
  切换账号: '切换账号',
  我的订单: '我的订单',
  账号设置: '账号设置',
  我的收藏: '我的收藏',
  登录账号管理: '登录账号管理',
  我收藏的商品和店铺: '我收藏的商品/店铺',
  我买过的商品和店铺: '我买过的商品/店铺',
  我看过的商品和店铺: '我看过的商品/店铺',
  关联商品: '关联商品',
  退出登录: '退出登录',
  当前账号已退出: '当前账号已退出',
  修改邮箱: '修改邮箱',
  新邮箱地址: '新邮箱地址',
  注销子账号: '注销子账号',
  用户信息更新成功: '用户信息更新成功',
  邮箱修改成功: '邮箱修改成功',
  目前您还没有创建店铺: '目前您还没有创建店铺',
  快速创建: '快速创建',
  切换B2B囤货业务: '切换B2B囤货业务',
  切换D2C代发业务: '切换D2C代发业务',
  店铺采购管理: '店铺采购管理',
  我的地址: '我的地址',
  // 用户配置项
  店铺平台: '店铺平台',
  店铺配置: '店铺配置',
  登录信息: '登录信息',
  修改密码: '修改密码',
  采购配置: '采购配置',
  附加项配置: '附加项配置',
  国际物流配置: '国际物流配置',
  您能接受的采购价格上涨: '您能接受的采购价格上涨',
  次品付费重购: '次品付费重购',
  接受次品重拍: '接受次品重拍',
  '接受次品重拍，有助于我们更好的为您完成C端订单':
    '接受次品重拍，有助于我们更好的为您完成C端订单',
  次品退货退款: '次品退货退款',
  '采购商品时，没有指定类目附加项时，使用全部附加项，两者不重复':
    '采购商品时，没有指定类目附加项时，使用全部附加项，两者不重复',
  '当您订单下有该类目商品时，我们将默认为您添加以下附加服务':
    '当您订单下有该类目商品时，我们将默认为您添加以下附加服务',
  水洗标信息配置: '水洗标信息配置',
  配置品牌专属水洗标: '配置品牌专属水洗标',
  打开全部: '打开全部',
  去配置: '去配置',
  使用类目: '使用类目',
  类目失效: '类目失效',
  选择物流公司: '选择物流公司',
  请选择物流公司: '请选择物流公司',
  国际面单主设定: '国际面单主设定',
  国际面单依赖主设定: '国际面单依赖主设定',
  联系方式: '联系方式',
  发货附加项: '发货附加项',
  添加新地址: '添加新地址',
  会社编号: '会社编号',
  日文收货地址: '日文收货地址',
  英文收货地址: '英文收货地址',
  修改地址: '修改地址',
  // 附加项
  一键自动配置: '一键自动配置',
  一键配置: '一键配置',
  我的类目: '我的类目',
  选择您要配置的类目: '选择您要配置的类目',
  选择商品附加服务: '选择商品附加服务',
  选择发货附加服务: '选择发货附加服务',
  选择我的物料: '选择我的物料',
  附加项: '附加项',
  辅料sku: '辅料sku',
  辅料名: '辅料名',
  预计在库数: '预计在库数',
  去补货: '去补货',
  编辑国际物流附加项: '编辑国际物流附加项',
  // 首页头部
  我的频道: '我的频道',
  市场购: '市场购',
  透明购: '透明购',
  D2C无仓库代发: 'D2C无仓库代发',
  B2B仓库囤货: 'B2B仓库囤货',
  采购平台: '采购平台',
  类目: '类目',
  中国语入力: '中国语入力',
  日本语入力: '日本语入力',
  详细检索: '详细检索',
  去登录: '去登录',
  // 搜索
  'THE CKB': 'THE CKB',
  1688: '1688',
  TaoBao: 'TaoBao',
  Tmall: 'Tmall',
  搜款网: '搜款网',
  网商园: '网商园',
  全部类目: '全部类目',
  搜索范围: '搜索范围',
  搜索关键词: '搜索关键词',
  重置条件: '重置条件',
  搜索历史: '搜索历史',
  热门推荐词: '热门推荐词',
  // 搜索列表
  采购渠道: '采购渠道',
  采购市场: '采购市场',
  关联我的商品: '关联我的商品',
  // 商品详情
  商品详情: '商品详情',
  商品来源: '商品来源',
  加入收藏夹: '加入收藏夹',
  商品金额: '商品金额',
  已选清单: '已选清单',
  手续费总额: '手续费总额',
  国际运费: '国际运费',
  附加项费用: '附加项费用',
  单价预估成本: '单价预估成本',
  请选择附加项: '请选择附加项',
  请选择附加项2: '请选择附加项',
  单品预估成本价: '单品预估成本价',
  相似商品: '相似商品',
  相似店铺: '相似店铺',
  加入购物车: '加入购物车',
  传输到我的店铺: '传输到我的店铺',
  下载商品图: '下载商品图',
  关联到我的店铺商品: '关联到我的店铺商品',
  X件可售: 'X件可售',
  商品添加至购物车: '商品添加至购物车',
  商品图下载成功: '商品图下载成功',
  '部分图片读取失败，请按需手动下载，正在开启自动下载':
    '部分图片读取失败，请按需手动下载，正在开启自动下载',
  购买数量: '购买数量',
  // 子账号店铺
  创建子账号: '创建子账号',
  创建店铺: '创建店铺',
  开店平台: '开店平台',
  平台名: '平台名',
  店铺品牌名: '店铺/品牌名',
  店铺URL地址: '店铺URL地址',
  店铺密钥: '店铺密钥',
  创建并授权店铺数据: '创建并授权店铺数据',
  请输入店铺所在的平台名称: '请输入店铺所在的平台名称（选填）',
  请输入店铺或品牌名: '请输入店铺或品牌名',
  请输入店铺访问链接: '请输入店铺访问链接',
  如需授权店铺API请阅读并同意: '如需授权店铺API请阅读并同意',
  利用规约: '利用规约',
  店铺地址不正确: '店铺地址不正确',
  创建店铺成功: '创建店铺成功',
  修改店铺成功: '修改店铺成功',
  店铺授权成功: '店铺授权成功',
  修改店铺信息: '修改店铺信息',
  授权状态: '授权状态',
  保存店铺: '保存店铺',
  未授权: '未授权',
  已授权: '已授权',
  去授权: '去授权',
  应用密钥: '应用密钥',
  应用ID: '应用ID',
  // 类目
  站外搜索: '站外搜索',
  // 市场购
  中国档口七日爆款: '中国档口七日爆款',
  推荐档口: '推荐档口',
  进入店铺: '进入店铺',
  // 我的频道
  我收藏的店铺: '我收藏的店铺',
  我看过的店铺: '我看过的店铺',
  我买过的店铺: '我买过的店铺',
  '担当推荐店铺（含档口）': '担当推荐店铺（含档口）',
  '推荐店铺（含档口）': '推荐店铺（含档口）',
  我看过的商品: '我看过的商品',
  我买过的商品: '我买过的商品',
  我收藏的商品: '我收藏的商品',
  担当推荐商品: '担当推荐商品',
  猜你喜欢的商品: '猜你喜欢的商品',
  // 平台频道
  平台频道: '平台频道',
  去购买: '去购买',
  去选品: '去选品',
  去看看: '去看看',
  主题市场: '主题市场',
  猜你喜欢的店铺: '猜你喜欢的店铺',
  品类市场: '品类市场',
  市场: '市场',

  // 青蛙频道
  青蛙频道: '青蛙频道',
  更多最新文章: '更多最新文章',
  采购相关: '采购相关',
  物流相关: '物流相关',
  优惠相关: '优惠相关',
  OME相关: 'OME相关',
  他社合作相关: '他社合作相关',
  热门文章: '热门文章',
  档案: '档案',
  // 文章
  上一篇: '上一篇',
  下一篇: '下一篇',
  // 购物车
  采购到库存: '采购到库存',
  C端直发: 'C端直发',
  选择店铺: '选择店铺',
  请选择店铺: '请选择店铺',
  检索平台: '检索平台',
  价格浮动百分比: '价格浮动百分比',
  '原有的商品缺货时，我们会帮你查找新的采购链接，所以请告诉我您能接受的采购价格区间变动':
    '原有的商品缺货时，我们会帮你查找新的采购链接，所以请告诉我您能接受的采购价格区间变动',
  创建组合商品: '创建组合商品',
  确认并支付: '确认并支付',
  收件人: '收件人',
  都道府县: '都道府县',
  市区町村: '市区町村',
  市: '市',
  区町村: '区町村',
  详细地址: '详细地址',
  邮编: '邮编',
  自定义订单编号: '自定义订单编号',
  购买店铺: '购买店铺',
  购买类型: '购买类型',
  收件人不能为空: '收件人不能为空',
  联系电话不能为空: '联系电话不能为空',
  都道府县不能为空: '都道府县不能为空',
  详细地址不能为空: '详细地址不能为空',
  邮编不能为空: '邮编不能为空',
  商品预估价格: '商品预估价格',
  商品预估附加项价格: '商品预估附加项价格',
  订单预估总价: '订单预估总价',
  当前余额: '当前余额',
  提交订单: '提交订单',
  '提示：此金额为预估报价，您下单后，该部分金额将会被冻结。等到该订单采购处理全部完成后，我们会自动解冻这部分金额，并按照实际产生的金额进行扣费。实际扣费详情您可以后续在资金明细页面或订单详情页面查看。':
    '提示：此金额为预估报价，您下单后，该部分金额将会被冻结。等到该订单采购处理全部完成后，我们会自动解冻这部分金额，并按照实际产生的金额进行扣费。实际扣费详情您可以后续在资金明细页面或订单详情页面查看。',
  // 组合
  组合商品名称不能为空: '组合商品名称不能为空',
  组合商品名称: '组合商品名称',
  组合商品规格: '组合商品规格',
  商品图片: '商品图片',
  商品规格: '商品规格',
  单组数量: '单组数量',
  保存并加入购物车: '保存并加入购物车',
  组合商品附加项: '组合商品附加项',
  选择附加项: '选择附加项',
  组合详情: '组合详情',
  组合图片: '组合图片',
  组合: '组合',
  // 通用
  全部: '全部',
  返回: '返回',
  其他: '其他',
  平台: '平台',
  变更: '变更',
  全选: '全选',
  商品名称: '商品名称',
  规格: '规格',
  在库数量: '在库数量',
  '可用库存/采购数量': '可用库存/采购数量',
  下单数量: '下单数量',
  起订量: '起订量',
  起订量件: '起订量(件)',
  单价: '单价',
  单价元: '单价(元)',
  总价元: '总价(元)',
  版费元: '版费(元)',
  小计: '小计',
  商品附加项: '商品附加项',
  商品附加项费用: '商品附加项费用',
  操作: '操作',
  编辑: '编辑',
  修改: '修改',
  合计: '合计',
  合计2: '合计',
  支付: '支付',
  账号: '账号',
  工作台: '工作台',
  OEM: 'OEM',
  意见反馈: '意见反馈',
  提示: '提示',
  提示2: '提示',
  提示3: '提示',
  创建: '创建',
  确定: '确定',
  确认: '确认',
  保存: '保存',
  同意: '同意',
  取消: '取消',
  撤回: '撤回',
  删除: '删除',
  元: '元',
  円: '円',
  件: '件',
  价格区间: '价格区间',
  风格: '风格',
  颜色: '颜色',
  尺码: '尺码',
  其他条件: '其他条件',
  综合: '综合',
  价格: '价格',
  成交额: '成交额',
  信用: '信用',
  销量: '销量',
  数量: '数量',
  排序: '排序',
  自定义: '自定义',
  去结算: '去结算',
  查看更多: '查看更多',
  默认: '默认',
  '上传中...': '上传中...',
  '已发送验证码请求，请勿重复发送请求': '已发送验证码请求，请勿重复发送请求',
  离开: '离开',
  注意: '注意',
  注意2: '注意',
  无: '無',
  暂无: '暂无',
  选填: '选填',
  批量删除: '批量删除',
  公司名: '公司名',
  收货地址: '收货地址',
  清关地址: '清关地址',
  设为默认: '设为默认',
  姓名En: '姓名(英文)',
  都道府县En: '都道府县(英文)',
  市区町村En: '市区町村(英文)',
  详细地址En: '详细地址(英文)',
  添加商品: '添加商品',
  购物车商品: '购物车商品',
  我的商品: '我的商品',
  图片: '图片',
  商品类型: '商品类型',
  至少选一个: '至少选一个',
  重置: '重置',
  '商品名称/SKU': '商品名称/SKU',
  加入组合: '加入组合',
  普通商品: '普通商品',
  OEM商品: 'OEM商品',
  组合商品: '组合商品',
  购物车为空: '购物车为空',
  上传图片: '上传图片',
  // 长文字说明
  '仅支持已授权店铺上传商品，该店铺未授权':
    '仅支持已授权店铺上传商品，该店铺未授权',
  '当您采购的商品价格出现变化时，或不能采购时我们将为您寻找其他相同的商品，所以请告诉我您能接受的价格变动幅度。':
    '当您采购的商品价格出现变化时，或不能采购时我们将为您寻找其他相同的商品，所以请告诉我您能接受的价格变动幅度。',
  '当商品出现问题时，我们将为您免费重新换货X次。超过X次每次Y元，最多不超过Z次。当不勾选时，每次出现次品时，我们都会询问您的意见，在进行处理，会影响您的购买效率。':
    '当商品出现问题时，我们将为您免费重新换货X次。超过X次每次Y元，最多不超过Z次。当不勾选时，每次出现次品时，我们都会询问您的意见，在进行处理，会影响您的购买效率。',
  // 占行
  // 占行
  // 占行
  // OEM问题
  创建寻源单: '创建寻源单',
  寻源单列表: '寻源单列表',
  复购申请列表: '复购申请列表',
  待接单: '待接单',
  待报价: '待报价',
  待商榷: '待商榷',
  寻源失败: '寻源失败',
  发布时间: '发布时间',
  起始日: '开始日',
  结束日: '终了日',
  寻源单详情: '寻源单详情',
  订单状态: '订单状态',
  下一步: '下一步',
  拒绝: '拒绝',
  拒绝2: '拒绝',
  确定下样品单: '确定下样品单',
  确定下大货单: '确定下大货单',
  评价: '评价',
  有: '有',
  没有: '没有',
  取消寻源单: '取消寻源单',
  确认下单: '确认下单',
  确认重新编辑: '确认重新编辑',
  确认申请退款: '确认申请退款',
  确认申请复购: '确认申请复购',
  '发布此寻源单需要收取XXX元服务费，请问是否确定发布':
    '发布此寻源单需要收取XXX元服务费，请问是否确定发布',
  '发布此寻源单无需收费，请问是否确定发布':
    '发布此寻源单无需收费，请问是否确定发布',
  示例: '示例',
  以上没有我需要的: '以上没有我需要的',
  '您想要一个什么类型的商品？': '您想要一个什么类型的商品？',
  '请问你要做什么辅料？': '请问你要做什么辅料？',
  请填写您需要的辅料: '请填写您需要的辅料',
  文件上传: '文件上传',
  '请问你有自己的方案吗？': '请问你有自己的方案吗？',
  '我有自己的想法，请THE CKB根据我的要求帮我生产':
    '我有自己的想法，请THE CKB根据我的要求帮我生产',
  '我没有自己的想法，希望THE CKB帮我推荐方案':
    '我没有自己的想法，希望THE CKB帮我推荐方案',
  '我有自己的想法，但是我也想看一下THE CKB的推荐方案':
    '我有自己的想法，但是我也想看一下THE CKB的推荐方案',
  请详细表述并上传您需要定制的辅料设计图或参考图片:
    '请详细表述并上传您需要定制的辅料设计图或参考图片',
  请详细描述您需要定制的款式信息: '请详细描述您需要定制的款式信息',
  请详细描述您需要定制的材质信息: '请详细描述您需要定制的材质信息',
  请详细描述您需要定制的尺寸信息: '请详细描述您需要定制的尺寸信息',
  请查看我们的款式推荐方案: '请查看我们的款式推荐方案',
  请查看我们的材质推荐方案: '请查看我们的材质推荐方案',
  请查看我们的尺寸推荐方案: '请查看我们的尺寸推荐方案',
  请查看我们的颜色推荐方案: '请查看我们的颜色推荐方案',
  请选择Logo印刷方案: '请选择Logo印刷方案',
  价格和起订量: '价格和起订量',
  总价: '总价',
  版费: '版费',
  选择色卡: '选择色卡',
  搜索色号: '搜索色号',
  色号或色卡名称: '色号或色卡名称',
  请至少选择一种色卡: '请至少选择一种色卡',
  已选色卡: '已选色卡',
  //
  '请问你对本次杂货OEM的初步需求是怎样的？':
    '请问你对本次杂货OEM的初步需求是怎样的？',
  '根据图片或样品，帮我生产出一模一样的产品。（包含加Logo）':
    '根据图片或样品，帮我生产出一模一样的产品。（包含加Logo）',
  '在既成品的基础上，我有一些改良的需求 。（包括颜色、材质、 功能、尺寸、设计等的改良）':
    '在既成品的基础上，我有一些改良的需求 。（包括颜色、材质、 功能、尺寸、设计等的改良）',
  '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务':
    '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务',
  '请问您是否有样品可邮寄？': '请问您是否有样品可邮寄？',
  '请问您需要附加Logo吗？': '请问您需要附加Logo吗？',
  请完善Logo信息: '请完善Logo信息',
  '请对logo颜色、尺寸、工艺、位置做说明':
    '请对logo颜色、尺寸、工艺、位置做说明',
  '请问您对本次寻源的工厂或产品资质有特殊要求吗？':
    '请问您对本次寻源的工厂或产品资质有特殊要求吗？',
  资质要求: '资质要求',
  请上传您的参考链接或图片: '请上传您的参考链接或图片',
  '请问您是否有式样书？': '请问您是否有式样书？',
  '我需要定制全新的产品，目前市场上没有既成品可参考。':
    '我需要定制全新的产品，目前市场上没有既成品可参考。',
  请上传式样书: '请上传式样书',
  '式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等':
    '式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等',
  '使用THE CKB帮助您制作式样书': '使用THE CKB帮助您制作式样书',
  '由于信息不足，THE CKB暂时无法为您提供寻源服务':
    '由于信息不足，THE CKB暂时无法为您提供寻源服务',
  请详细说明您需要改动的地方: '请详细说明您需要改动的地方',
  '如果需要改动的点已经在式样书中完全展现，可以略过，否则可做补充说明':
    '如果需要改动的点已经在式样书中完全展现，可以略过，否则可做补充说明',
  补充说明: '补充说明',
  上传文件: '上传文件',
  请完善信息: '请完善信息',
  请问您是否可以提供样衣邮寄: '请问您是否可以提供样衣邮寄',
  我有样衣: '我有样衣',
  我没有样衣: '我没有样衣',
  'THE CKB地址': 'THE CKB地址',
  请填写物流单号: '请填写物流单号',
  //
  '请问你对本次服装OEM的初步需求是怎样的？':
    '请问你对本次服装oem的初步需求是怎样的？',
  '只需要生产出和图片或链接看起来一样的产品，对面料没有任何要求，且不需要有任何设计上的改动。':
    '只需要生产出和图片或链接看起来一样的产品，对面料没有任何要求，且不需要有任何设计上的改动。',
  '风险告知：A的情况，此选项不寄实物样品给客户，只通过样衣图片在线上进行确认。此选项优点为出样快，缺点为THE CKB只保证成衣外观和客户提供的图片接近一致无法保证和原链接衣服材质保持一致。请知悉！':
    '风险告知：A的情况，此选项不寄实物样品给客户，只通过样衣图片在线上进行确认。此选项优点为出样快，缺点为THE CKB只保证成衣外观和客户提供的图片接近一致无法保证和原链接衣服材质保持一致。请知悉！',
  '我有样衣，希望THE CKB帮我生产出和样衣一模一样的衣服。':
    '我有样衣，希望THE CKB帮我生产出和样衣一模一样的衣服。',
  '我有样衣，但我对设计/面料/尺寸等，有希望改动的地方。':
    '我有样衣，但我对设计/面料/尺寸等，有希望改动的地方。',
  '我只有参考图片或链接，且我有需要改动的地方或我对面料有拘泥。':
    '我只有参考图片或链接，且我有需要改动的地方或我对面料有拘泥。',
  '此种情况您需要尽可能提供一件样衣到THE CKB作为参考，或者您需要提供详细的式样书，如果您没有式样书，可以联系THE CKB使用式样书制作服务':
    '此种情况您需要尽可能提供一件样衣到THE CKB作为参考，或者您需要提供详细的式样书，如果您没有式样书，可以联系THE CKB使用式样书制作服务',
  '我没有样衣或参考图片/链接，但我有式样书，希望THE CKB根据式样书帮我进行生产。':
    '我没有样衣或参考图片/链接，但我有式样书，希望THE CKB根据式样书帮我进行生产。',
  '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务；式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等':
    '既无参考图片也无式样书的情况，无法发起寻源，请联系对应担当提供制作式样书服务；式样书必须包含产品的色卡、尺寸、特殊工艺、面料信息等',
  请填写你想定制产品的基本信息: '请填写你想定制产品的基本信息',
  请填写产品名称: '请填写产品名称',
  请至少填写一条完整的产品信息: '请至少填写一条完整的产品信息',
  产品信息说明:
    '商品のサイズ分類を記載してください。サイズが複数ある場合は、行追加しサイズを入力してください。例 M,L,XL,30cm＊40cm＊20cm　など',
  '不知道，但是我可以邮寄面料样布，希望THE CKB帮我找到和样布一样的面料':
    '不知道，但是我可以邮寄面料样布，希望THE CKB帮我找到和样布一样的面料',
  '请问你是否知道面料具体信息？': '请问你是否知道面料具体信息？',
  '知道，我可以提供面料信息和具体的色卡信息':
    '知道，我可以提供面料信息和具体的色卡信息',
  '不知道，希望THE CKB帮我找到和样衣或参考图片一样的面料':
    '不知道，希望THE CKB帮我找到和样衣或参考图片一样的面料',
  '不知道，希望THE CKB可以根据我的需求，给我推荐合适的面料':
    '不知道，希望THE CKB可以根据我的需求，给我推荐合适的面料',
  请提供具体的色卡信息: '请提供具体的色卡信息',
  请描述一下您对面料的需求: '请描述一下您对面料的需求',
  '请大致描述一下希望布料的外观或功能上的需求，如:弹性好，柔软等':
    '请大致描述一下希望布料的外观或功能上的需求，如:弹性好，柔软等',
  上传面料图片: '上传面料图片',
  '请大致描述一下希望改动哪些方面,如:材质、设计、颜色、尺寸等':
    '请大致描述一下希望改动哪些方面,如:材质、设计、颜色、尺寸等',
  '请问你能够提供尺码的具体尺寸吗？': '请问你能够提供尺码的具体尺寸吗？',
  '我有尺码对应的尺寸数值。': '我有尺码对应的尺寸数值。',
  '根据服装生产标准，尺寸相差 1-3cm 都属于正常现象，不作为不良品判断，请知悉':
    '根据服装生产标准，尺寸相差 1-3cm 都属于正常现象，不作为不良品判断，请知悉',
  '我没有数值，请参考链接尺寸。': '我没有数值，请参考链接尺寸。',
  '我没有数值，请THE CKB提供。': '我没有数值，请THE CKB提供。',
  请提供尺码的具体尺寸: '请提供尺码的具体尺寸',
  尺码模板: '尺码模板',
  模板下载: '模板下载',
  模板下载2: '模板下载',
  上传模板: '上传模板',
  '请先下载对应模板，填写完成后上传': '请先下载对应模板，填写完成后上传',
  请输入产品的下单需求: '请输入产品的下单需求',
  'THE CKB的报价与希望起订量和价格是否匹配，是我们判定是否为您寻源成功的判断依据。请您客观的填写。如果您的希望和市场行情差异过大，我们会之后先联系您，提出修改建议，再开始为您寻源报价。':
    'THE CKB的报价与希望起订量和价格是否匹配，是我们判定是否为您寻源成功的判断依据。请您客观的填写。如果您的希望和市场行情差异过大，我们会之后先联系您，提出修改建议，再开始为您寻源报价。',
  寻源备注: '寻源备注',
  '如果您对本次寻源还有其他特殊需求，请在以下输入您的需求':
    '如果您对本次寻源还有其他特殊需求，请在以下输入您的需求',
  已成功创建寻源单: '已成功创建寻源单',
  创建寻源单说明:
    'まだ、対応開始されていません。管理画面で内容確認の上、依頼提出をお願いします',
  '式样书(例)': '式样书(例)',
  棉100: '綿100%',
  可多选: '可多选',
  尺码信息: '尺码信息',
  是否需要加logo: '是否需要加logo',
  期望交期时间: '期望交期时间',
  期望最低起订量: '期望最低起订量',
  关闭: '关闭',
  关闭2: '关闭',
  客户补充部分: '客户补充部分',
  附加说明: '附加说明',
  已选: '已选',
  未选: '未选',
  您可以点击此处: '您可以点击此处',
  产品图片: '产品图片',
  产品规格: '产品规格',
  备注: '备注',
  附加费选项: '附加费选项',
  订单标题: '订单标题',
  品牌: '品牌',
  总计数量: '总计数量',
  '总计(折扣前RMB)': '总计(折扣前RMB)',
  '总计(折扣后RMB)': '总计(折扣后RMB)',
  估计金额: '估计金额',
  购物车数量不能小于X: '购物车数量不能小于X',
  普通订单: '普通订单',
  组合商品订单: '组合商品订单',
  OEM订单: 'OEM订单',
  //
  报价已过期: '报价已过期',
  复购申请编号: '复购申请编号',
  申请状态: '申请状态',
  //
  请填写: '请填写',
  请上传: '请上传',
  请至少选择一种色卡或上传图片: '请至少选择一种色卡或上传图片',
  链接和图片必须填一个: '链接和图片必须填一个',
  请提供面料材质和色卡信息: '请提供面料材质和色卡信息',
  请填写具体的面料材质信息: '请填写具体的面料材质信息',
  '我没有数值，请参考样衣尺寸。': '我没有数值，请参考样衣尺寸。',
  '以上为参考报价，具体报价需要以最终报价为准 ':
    '以上为参考报价，具体报价需要以最终报价为准',
  该订单不支持修改属性: '该订单不支持修改属性',
  请至少选择或上传一种色卡: '请至少选择或上传一种色卡',
  请填写款式说明: '请填写款式说明',
  请填写材质详细说明: '请填写材质详细说明',
  请填写尺寸详细说明: '请填写尺寸详细说明',
  请上传Logo: '请上传Logo',
  请上传尺码表: '请上传尺码表',
  请填写期望价格: '请填写期望价格',
  请填写期望最低起订量: '请填写期望最低起订量',
  请选择期望交期时间: '请选择期望交期时间',
  重新创建寻源单: '重新创建寻源单',
  查看寻源单列表: '查看寻源单列表',
  请输入您想要的详细信息: '请输入您想要的详细信息',
  'THE CKB的款式推荐方案': 'THE CKB的款式推荐方案',
  'THE CKB的材质推荐方案': 'THE CKB的材质推荐方案',
  'THE CKB的尺寸推荐方案': 'THE CKB的尺寸推荐方案',
  印刷方案: '印刷方案',
  请输入您的订单信息: '请输入您的订单信息',
  规格及起订量: '规格及起订量',
  '棉100%': '棉100%',
  '上次寻源未完成，是否继续': '上次寻源未完成，是否继续',
  /**
   *
   * 没有可优先发货的商品1
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   *
   */
  重新寻源: '重新寻源',
  店铺不存在: '店铺不存在',
  没有更多了: '没有更多了',
  暂无平台: '暂无平台',
  输入FAQs关键词: '输入FAQs关键词',
  收藏商品: '收藏商品',
  收藏店铺: '收藏店铺',
  多为我推荐此类型商品: '多为我推荐此类型商品',
  多为我推荐此类型店铺: '多为我推荐此类型店铺',
  不再推荐此商品: '不再推荐此商品',
  不再推荐此店铺: '不再推荐此店铺',
  商品收藏成功: '商品收藏成功',
  店铺收藏成功: '店铺收藏成功',
  '感谢反馈，我们将为你推荐更加准确的商品':
    '感谢反馈，我们将为你推荐更加准确的商品',
  '感谢反馈，我们将为你推荐更加准确的店铺':
    '感谢反馈，我们将为你推荐更加准确的店铺',
  注销账号: '注销账号',
  提现: '提现',
  '您的账号中存在以下未处理完结事件，不能注销。':
    '您的账号中存在以下未处理完结事件，不能注销。',
  账户余额X元: '账户余额X元',
  提现申请: '提现申请',
  X笔采购订单: 'X笔采购订单',
  X条充值任务未完成: 'X条充值任务未完成',
  批量编辑附加项: '批量编辑附加项',
  工厂直营: '工厂直营',
  组合商品不能再组合: '组合商品不能再组合',
  OEM样品单不能组合: 'OEM样品单不能组合',
  '订单已生成，请随时关注订单动态': '订单已生成，请随时关注订单动态',
  '5s后跳转订单详情': '5s后跳转订单详情',
  '15s后跳转订单详情': '15s后跳转订单详情',
  '系统检查到，您未安装采购扩展程序，现在安装采购更方便直接在1688，天猫，淘宝官网THE直达商品可以添加到采购系统购物车中。现在马上安装':
    '系统检查到，您未安装采购扩展程序，现在安装采购更方便直接在1688，天猫，淘宝官网THE直达商品可以添加到采购系统购物车中。现在马上安装',
  包邮: '包邮',
  赠送退货运费险: '赠送退货运费险',
  新品: '新品',
  正品保障: '正品保障',
  公益宝贝: '公益宝贝',
  '7+天内退货': '7+天内退货',
  折扣: '折扣',
  搭配满减: '搭配满减',
  满就减: '满就减',
  货到付款: '货到付款',
  '48小时内发货': '48小时内发货',
  实力商家: '实力商家',
  超级工厂: '超级工厂',
  加工定制: '加工定制',
  人气: '人气',
  访问令牌: '访问令牌',
  请填写正确的访问令牌: '请填写正确的访问令牌',
  组合商品规格不能为空: '组合商品规格不能为空',
  选择一张图片作为组合商品主图: '选择一张图片作为组合商品主图',
  查看组合列表: '查看组合列表',
  当前购物车共X种商品: '当前购物车共X种商品',
  X件商品已添加至购物车: 'X件商品已添加至购物车',
  '库存过低不能下单，请调整发货量或及时补充库存':
    '库存过低不能下单，请调整发货量或及时补充库存',
  回到首页: '回到首页',
  同步商品: '同步商品',
  fnsku: 'fnsku',
  asin: 'asin',
  '请输入Amazon sku': '请输入Amazon sku',
  '请搜索需要绑定的Amazon sku': '请搜索需要绑定的Amazon sku',
  附加项未配置箱唛: '附加项未配置箱唛',
  附加项未配置贴标签: '附加项未配置贴标签',
  '海外仓sku(fnsku)': '海外仓sku(fnsku)',
  补货数量: '补货数量',
  未提出: '未提出',
  已提出: '已提出',
  已作废: '已作废',
  'FNSKU/ASIN': 'FNSKU/ASIN',
  '商品名称/Amazon sku': '商品名称/Amazon sku',
  '品名/平台sku': '品名/平台sku',
  计划发货量: '计划发货量',
  是否确认提出: '是否确认提出',
  是否确认取消: '是否确认取消',
  作废成功: '作废成功',
  提交成功: '提交成功',
  提交成功2: '提交成功',
  国际发货单标题: '国际发货单标题',
  发货状态: '发货状态',
  发货类型: '发货类型',
  批量加购: '批量加购',
  '点击完结 单品可以转普通商品库存': '点击完结 单品可以转普通商品库存',
  '存在待组商品 请尽快加购组合。': '存在待组商品 请尽快加购组合。',
  物流信息: '物流信息',
  国际单号回传后不可修改: '国际单号回传后不可修改',
  收件人邮箱: '收件人邮箱',
  选择订单时间: '选择订单时间',
  订单付款日期区间: '订单付款日期区间',
  未下单: '未下单',
  已下单: '已下单',
  店铺订单号: '店铺订单号',
  订单时间: '订单时间',
  采购状态: '采购状态',
  订单金额: '订单金额',
  收货信息: '收货信息',
  商品图: '商品图',
  '商品名/sku': '商品名/sku',
  采购链接sku: '采购链接sku',
  同步订单数据: '同步订单数据',
  一键下单: '一键下单',
  '编辑物流/地址': '编辑地址',
  是否删除: '是否删除',
  发货附加项编辑成功: '发货附加项编辑成功',
  留在此页: '留在此页',
  开始时间: '开始时间',
  质检中: '质检中',
  待发货: '待发货',
  '当前申请取消的商品，存在多个商品状态，确认取消后：':
    '当前申请取消的商品，存在多个商品状态，确认取消后：',
  '“X”状态商品，申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。':
    '“X”状态商品，申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。',
  '“X”状态，申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。':
    '“X”状态，申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。',
  '请确认是否申请取消？': '请确认是否申请取消？',
  '“X”状态商品，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内；':
    '“X”状态商品，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内；',
  '“X”状态商品，不可申请取消（系统将自动忽略）':
    '“X”状态商品，不可申请取消（系统将自动忽略）',
  '当前申请取消的商品，商品状态均为“X”状态,':
    '当前申请取消的商品，商品状态均为“X”状态,',
  '申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。':
    '申请取消成功后，系统将自动取消商品的采购与发货，冻结金额在订单结算后返回至可用余额内。',
  '当前申请取消的商品，商品状态均为“X”状态，不可申请取消！':
    '当前申请取消的商品，商品状态均为“X”状态，不可申请取消！',
  '当前申请取消的商品，商品状态均为“X”状态，申请取消成功后，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内':
    '当前申请取消的商品，商品状态均为“X”状态，申请取消成功后，系统将自动取消商品的采购，冻结金额在订单结算后返回至可用余额内',
  再次下单: '再次下单',
  组合信息: '组合信息',
  结算中心查看明细: '结算中心查看明细',
  费用名称: '费用名称',
  '结算总价（元）': '结算总价（元）',
  问题联络: '问题联络',
  冻结: '冻结',
  解冻: '解冻',
  结算: '结算',
  重拍冻结: '重拍冻结',
  销售单价: '销售单价',
  结算数量: '结算数量',
  结算总价: '结算总价',
  点击上传凭证: '点击上传凭证',
  みずほ銀行: 'みずほ銀行',
  商品代金结算: '商品代金结算',
  国内运费: '国内运费',
  国际物流费用: '国际物流费用',
  国际运费重量差补扣: '国际运费重量差补扣',
  国际运费附加项补扣: '国际运费附加项补扣',
  销毁费补扣: '销毁费补扣',
  偏远地区费补扣: '偏远地区费补扣',
  仓储费补扣: '仓储费补扣',
  超长超重费补扣: '超长超重费补扣',
  关税补扣: '关税补扣',
  改派费补扣: '改派费补扣',
  特殊处理费补扣: '特殊处理费补扣',
  扣件费补扣: '扣件费补扣',
  退件费补扣: '退件费补扣',
  冻结总价: '冻结总价',
  解冻总价: '解冻总价',
  重拍冻结商品代金: '重拍冻结商品代金',
  冻结商品代金: '冻结商品代金',
  解冻商品代金: '解冻商品代金',
  冻结总数量: '冻结总数量',
  解冻总数量: '解冻总数量',
  手续费: '手续费',
  次品重买总次数: '次品重买总次数',
  纸箱总数量: '纸箱总数量',
  装箱总数量: '装箱总数量',
  气泡膜总数量: '气泡膜总数量',
  托盘总数量: '托盘总数量',
  箱子总数量: '箱子总数量',
  结算总数量: '结算总数量',
  我的默认附加项: '我的默认附加项',
  我的类目附加项: '我的类目附加项',
  商品总金额: '商品总金额',
  发货单: '发货单',
  箱: '箱',
  钱包: '钱包',
  收藏: '收藏',
  记录: '记录',
  足迹: '足迹',
  没有可优先发货的商品: '没有可优先发货的商品',
  是否确认优先发货: '是否确认优先发货',
  优先发货成功: '优先发货成功',
  没有可申请取消的商品: '没有可申请取消的商品',
  是否确认删除: '是否确认删除',
  搜索商品: '搜索商品',
  '您将要删除X条商品数据，删除后将无法恢复':
    '您将要删除X条商品数据，删除后将无法恢复',
  请输入商品名: '请输入商品名',
  请输入商品名3: '请输入商品名',
  选择收货地址: '选择收货地址',
  国际发货标题: '国际发货标题',
  是否确定加购大货: '是否确定加购大货',
  加购大货: '加购大货',
  确定加购样品: '确定加购样品',
  加购样品: '加购样品',
  库存还有X件商品或辅料: '库存还有X件商品或辅料',
  去处理: '去处理',
  '账号注销后我们将不再保存您的任何账号信息，是否注销？':
    '账号注销后我们将不再保存您的任何账号信息，是否注销？',
  直行台: '直行台',
  账户概览: '账户概览',
  同步订单: '同步订单',
  订单详情: '订单详情',
  购买过: '购买过',
  消息: '消息',
  商品管理: '商品管理',
  关联商品库: '关联商品库',
  我的组合商品: '我的组合商品',
  国际发货: '国际发货',
  国际发货列表: '国际发货列表',
  国际发货详情: '国际发货详情',
  补货计划: '补货计划',
  资金管理: '资金管理',
  授权管理: '授权管理',
  再购入: '再购入',
  下单: '下单',
  同步商品信息: '同步商品信息',
  库存数: '库存数',
  可售: '可售',
  可用库存: '可用库存',
  已锁定: '已锁定',
  待处理次品数: '待处理次品数',
  导出成功: '导出成功',
  'THE CKB发货单号': 'THE CKB发货单号',
  复购: '复购',
  筛选条件: '筛选条件',
  '客户商品sku/海外仓sku': '客户商品sku/海外仓sku',
  '平台客户sku/商品名称': '平台客户sku/商品名称',
  客户SKU: '客户SKU',
  更新: '更新',
  平台商品信息: '平台商品信息',
  'AMAZON库存(可售)': 'AMAZON库存(可售)',
  'AMAZON库存(入库)': 'AMAZON库存(入库)',
  'AMAZON库存(不可售)': 'AMAZON库存(不可售)',
  预计总库存: '预计总库存',
  绑定: '绑定',
  解绑: '解绑',
  确认签收: '确认签收',
  '是否确认签收？': '是否确认签收？',
  '是否确认取消国际发货？ 仓库已在作业中的发货单无法取消。':
    '是否确认取消国际发货？ 仓库已在作业中的发货单无法取消。',
  '小计（元）': '小计（元）',
  实际发货数量: '实际发货数量',
  提出: '提出',
  已确认: '已确认',
  尺寸: '尺寸',
  /**
   *
   * 补充翻译3
   */
  寻源单号: '寻源单号',
  大货单: '大货单',
  样品单: '样品单',
  预计可发货数: '预计可发货数',
  查看订单详情: '查看订单详情',
  购买数量不可为空: '购买数量不可为空',
  购买数量不可低于起订量: '购买数量不可低于起订量',
  子商品总数不能少于2件: '子商品总数不能少于2件',
  批量编辑商品附加项: '批量编辑商品附加项',
  '存在不足起订量的商品，请修改数量': '存在不足起订量的商品，请修改数量',
  需要填写收货地址: '需要填写收货地址',
  添加收货地址: '添加收货地址',
  payoneer充值记录: 'payoneer充值记录',
  我知道了: '我知道了',
  '存入金额（USD）': '存入金额（USD）',
  待初审: '待初审',
  待终审: '待终审',
  已通过: '已通过',
  上传成功: '上传成功',
  参考单价: '参考单价',
  冻结数量: '冻结数量',
  扣费日: '扣费日',
  上次扣费日: '上次扣费日',
  上架日: '上架日',
  免费保管天数: '免费保管天数',
  计费天数: '计费天数',
  '当前账号下无店铺，请创建店铺后再执行操作':
    '当前账号下无店铺，请创建店铺后再执行操作',
  /**
   *
   * 补充翻译4
   */
  普通发货: '普通发货',
  FBA发货: 'FBA发货',
  收货仓: '收货仓',
  '如果您当前存在部分订单未完成的话，您账户可用余额中我们将会自动为您留下当下账户冻结金额*1的金额，来确保账户有足够的金额来支付国际运费后顺利发货。所以您目前可转账的金额为：账户可用余额-冻结金额':
    '如果您当前存在部分订单未完成的话，您账户可用余额中我们将会自动为您留下当下账户冻结金额*1的金额，来确保账户有足够的金额来支付国际运费后顺利发货。所以您目前可转账的金额为：账户可用余额-冻结金额',
  本公司接受银行: '本公司接受银行',
  汇款人姓名: '汇款人姓名',
  汇款时间: '汇款时间',
  汇款凭证: '汇款凭证',
  点击上传: '点击上传',
  良品入库: '良品入库',
  不良品: '不良品',
  付费重拍: '付费重拍',
  本次重拍费用X円: '本次重拍费用X円',
  '接受次品/缺货自动付费重拍（接受自动重拍，有助于我们更快的为您完成订单采购）':
    '接受次品/缺货自动付费重拍（接受自动重拍，有助于我们更快的为您完成订单采购）',
  更换尺码: '更换尺码',
  更换款式: '更换款式',
  '请输入链接(必填)': '请输入链接(必填)',
  同款链接: '同款链接',
  点击可查看: '点击可查看',
  类似款链接: '类似款链接',
  等待原链接: '等待原链接',
  下单原链接: '下单原链接',
  '下单原链接（多出数量保留库存）': '下单原链接（多出数量保留库存）',
  申请成功: '申请成功',
  申请成功2: '申请成功',
  请确认尺码: '请确认尺码',
  请确认颜色: '请确认颜色',
  '请确认设计（款式）': '请确认设计（款式）',
  '全网断货，建议取消': '全网断货，建议取消',
  // '原URL缺货，新的URL内商品是X元，请确认':
  //   '原URL缺货，新的URL内商品是X元，请确认',
  '原商品缺货，找到了类似商品，请确认': '原商品缺货，找到了类似商品，请确认',
  '预售商品。预计下单后X天后能发货，要等吗？':
    '预售商品。预计下单后X天后能发货，要等吗？',
  '找到新的现货链接，是否可以购买？': '找到新的现货链接，是否可以购买？',
  '此商品的最小起订量是X件。请确认是否购买。':
    '此商品的最小起订量是X件。请确认是否购买。',
  '找到符合下单量的新链接，是否可以购买。':
    '找到符合下单量的新链接，是否可以购买。',
  '原商品质量不佳，推荐在新链接采购。': '原商品质量不佳，推荐在新链接采购。',
  到错货: '到错货',
  少件: '少件',
  多件: '多件',
  快递扫不出: '快递扫不出',
  // 颜色差异: '颜色差异',
  // 商品有中文: '商品有中文',
  '配件差异（口袋，腰带，纽扣，拉链，拉绳等）':
    '配件差异（口袋，腰带，纽扣，拉链，拉绳等）',
  // logo差异: 'logo差异',
  // 尺码差异: '尺码差异',
  '设计差异（压线，领口，袖口，花纹，衣服设计等）':
    '设计差异（压线，领口，袖口，花纹，衣服设计等）',
  '材质/面料差异': '材质/面料差异',
  色差: '色差',
  // '污渍/斑点/水印': '污渍/斑点/水印',
  // 破损: '破损',
  // 线头: '线头',
  // 接缝不良: '接缝不良',
  // 抽丝: '抽丝',
  // 针眼: '针眼',
  // 霉菌: '霉菌',
  // 生锈: '生锈',
  // 纽扣破损: '纽扣破损',
  // 拉链破损: '拉链破损',
  // 附属品缺陷: '附属品缺陷',
  // 有气味: '有气味',
  // 其他不良: '其他不良',
  'THE CKB档口': 'THE CKB档口',
  '我们的 OEM 仅适用于商务舱和头等舱成员。如果您想使用OEM，请从[会员信息]更改会员等级。如果您有任何问题，请联系我们的在线客服。':
    '我们的 OEM 仅适用于商务舱和头等舱成员。如果您想使用OEM，请从[会员信息]更改会员等级。如果您有任何问题，请联系我们的在线客服。',
  充值会员: '充值会员',
  购买数量不可低于X件: '购买数量不可低于X件',
  /**
   *
   */
  '平台库存（处理中）': '平台库存（处理中）',
  '平台库存（已锁定）': '平台库存（已锁定）',
  '平台库存（可用库存）': '平台库存（可用库存）',
  '平台库存（待处理次品数）': '平台库存（待处理次品数）',
  转账金额不能为0: '转账金额不能为0',
  '同步中...': '同步中...',
  '同步完成-执行刷新': '同步完成-执行刷新',
  我的工作台: '我的工作台',
  订单管理: '订单管理',
  API同步订单: 'API同步订单',
  库存管理: '库存管理',
  寻源列表: '寻源列表',
  OEM复购: 'OEM复购',
  'API/子账号配置': 'API/子账号配置',
  会员相关: '会员相关',
  会员办理: '会员办理',
  国际配送管理: '国际配送管理',
  FBA补货计划: 'FBA补货计划',
  国际发货管理: '国际发货管理',
  国际发货售后: '国际发货售后',
  主账号资金明细: '主账号资金明细',
  店铺资金明细: '店铺资金明细',
  OEM寻源: 'OEM寻源',
  全部店铺数据: '全部店铺数据',
  '这是您与THE CKB相处的第X天': '这是您与THE CKB相处的第X天',
  升级会员: '升级会员',
  钱包余额: '钱包余额',
  未关联的商品: '未关联的商品',
  API同步异常订单: 'API同步异常订单',
  商品在库: '商品在库',
  在库辅料: '在库辅料',
  昨日下单金额: '昨日下单金额',
  昨日API下单量: '昨日API下单量',
  昨日下单数量: '昨日下单数量',
  昨日采购金额: '昨日采购金额',
  昨日采购量: '昨日采购量',
  昨日发货量: '昨日发货量',
  待发库存数: '待发库存数',
  待确认补货计划: '待确认补货计划',
  待确认补货计划1: '待确认补货计划',
  未绑定商品: '未绑定商品',
  /**
   *
   *
   */
  对折: '对折',
  不使用商品番号: '不使用商品番号',
  不使用客户商品sku: '不使用客户商品sku',
  关联商品库填写: '关联商品库填写',
  请填写会社名: '请填写会社名',
  请填写会社地址: '请填写会社地址',
  '图片格式支持jpg，png。': '图片格式支持jpg，png。',
  'LOGO图片比例为1:1，在水洗标打印时转变为黑白色':
    'LOGO图片比例为1:1，在水洗标打印时转变为黑白色',
  缝制样式: '缝制样式',
  请选择商品番号填写方式: '请选择商品番号填写方式',
  '更新中...': '更新中...',
  '更新完成-执行刷新': '更新完成-执行刷新',
  Amazon在庫数更新: 'Amazon在庫数更新',
  购买时间: '购买时间',
  收藏时间: '收藏时间',
  /**
   *
   */
  更新时间: '更新时间',
  请选择需要复购的商品: '请选择要复购的商品',
  请选择需要优先发货的商品: '请选择需要优先发货的商品',
  请选择需要取消的商品: '请选择需要取消的商品',
  请选择需要售后的商品: '请选择需要售后的商品',
  请选择需要导出的订单: '请选择需要导出的订单',
  '自動発注をOFFにしました。': '自動発注をOFFにしました。',
  店铺url和访问令牌不能为空: '店铺url和访问令牌不能为空',
  未关联sku数量: '未关联sku数量',
  星期一: '星期一',
  星期二: '星期二',
  星期三: '星期三',
  星期四: '星期四',
  星期五: '星期五',
  星期六: '星期六',
  星期日: '星期日',
  平台库存: '平台库存',
  AMAZON库存: 'AMAZON库存',
  不可售: '不可售',
  入库: '入库',
  /**
   *
   */
  '商品“已上架”之前的状态下的总数量': '商品“已上架”之前的状态下的总数量',
  已使用准备发给您的商品: '已使用准备发给您的商品',
  可使用的正品数量: '可使用的正品数量',
  '仓库发现商品次品且无法退款，进入您的次品库存':
    '仓库发现商品次品且无法退款，进入您的次品库存',
  弊社受取銀行: '弊社受取銀行',
  横浜駅前支店: '横浜駅前支店',
  店番292: '店番292',
  口座番号: '口座番号',
  '普通預金  4014779': '普通預金  4014779',
  口座名: '口座名',
  '株式会社  SNIFF JAPAN': '株式会社  SNIFF JAPAN',
  料金表: '料金表',
  当前单价: '当前单价',
  国際配送依頼番号: '国際配送依頼番号',
  'Amazon sku绑定成功': 'Amazon sku绑定成功',
  收据: '收据',
  /**
   *
   */
  一键绑定: '一键绑定',
  导出: '导出',
  请确认售后信息: '请确认售后信息',
  解冻数量: '解冻数量',
  通过FBA补货计划发货: '通过FBA补货计划发货',
  海外仓sku不能为空: '海外仓sku不能为空',
  /**
   *
   */
  缺货: '缺货',
  传输商品信息到店铺: '传输商品信息到店铺',
  '创建成功，并已为您自动创建关联': '创建成功，并已为您自动创建关联',
  查看关联商品库: '查看关联商品库',
  领收书下载: '领收书下载',
  领收书: '领收书',
  流水: '流水',
  是否确定加购样品: '是否确定加购样品',
  查看报价信息: '查看报价信息',
  加购成功: '加购成功',
  汇款金额必须大于0: '汇款金额必须大于0',
  确认取消: '确认取消',
  '请绑定 Amazon sku': '请绑定 Amazon sku',
  是否确认取消授权: '是否确认取消授权',
  余额支付: '残高からお支払い',
  申込月数: '申込月数',
  转账成功: '转账成功',
  銀行振込: '銀行振込',
  /**
   *
   */
  换绑: '换绑',
  '绑定Amazon sku': '绑定Amazon sku',
  '申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。':
    '申请取消成功后，系统将自动取消商品的发货行为，并将商品保留库存。',
  请确认本次重拍费用: '请确认本次重拍费用',
  '您的余额不足，请充值后再次支付': '您的余额不足，请充值后再次支付',
  '5s后跳转充值页面': '5s后跳转充值页面',
  '5s后跳转附加项配置': '5s后跳转附加项配置',
  下单失败: '下单失败',
  /**
   *
   */
  商品关联列表: '商品关联列表',
  修改关联: '修改关联',
  编辑附加项: '编辑附加项',
  '为您的商品编辑的附加项，会再API下单时直接使用。如需修改请点击此处。':
    '为您的商品编辑的附加项，会再API下单时直接使用。如需修改请点击此处。',
  请选择发货附加项: '请选择发货附加项',
  请上传图片: '请上传图片',
  一键删除: '一键删除',
  店铺商品信息: '店铺商品信息',
  '如果是个人，请输入无': '如果是个人，请输入无',
  订单结算费用详情: '订单结算费用详情',
  物流详情: '物流详情',
  订单搜索: '订单搜索',
  发货详情: '发货详情',
  输入你的登陆密码: '输入你的登陆密码',
  是否确认复购: '是否确认复购',
  复购成功: '复购成功',
  不同意: '不同意',
  '未处理，请点击【提出】按钮': '未处理，请点击【提出】按钮',
  OEM报价: 'OEM报价',
  '处理中，需要1～2分钟': '处理中，需要1～2分钟',
  我的OEM商品: '我的OEM商品',
  转到运输公司设置: '转到运输公司设置',
  '点击上方按钮编辑你常用的<span>快捷功能</span>':
    '点击上方按钮编辑你常用的<span>快捷功能</span>',
  '拉动板块可<span>调整功能排序</span>哦！':
    '拉动板块可<span>调整功能排序</span>哦！',
  '编辑后的功能入口在上方显示，你需要的功能直接点击前往即可':
    '编辑后的功能入口在上方显示，你需要的功能直接点击前往即可',
  '<span>透明购</span>: 为首页，并为您推荐1688、淘宝、天猫的商品查找专区。<br/><span>市场购</span>: THE CKB扩展的市场采购货品更全，价格更低。<br/><span>我的频道</span>: 你在本平台的喜欢的商品都在这里。 <br/>任何情况下，点击<span>logo</span>回到本页面':
    '<span>透明购</span>: 为首页，并为您推荐1688、淘宝、天猫的商品查找专区。<br/><span>市场购</span>: THE CKB扩展的市场采购货品更全，价格更低。<br/><span>我的频道</span>: 你在本平台的喜欢的商品都在这里。 <br/>任何情况下，点击<span>logo</span>回到本页面',
  '选择你感兴趣的<span>平台</span>和<span>类目</span>，再输入关键词，搜索更精准':
    '选择你感兴趣的<span>平台</span>和<span>类目</span>，再输入关键词，搜索更精准',
  '点击“X”在THE CKB平台搜索': '点击“X”在THE CKB平台搜索',
  '点击“X”跳转你选择的平台搜索。': '点击“X”跳转你选择的平台搜索。',
  'THE CKB为你提供了多个选购平台。根据你的<span>采购类型迅速选品</span>。':
    'THE CKB为你提供了多个选购平台。根据你的<span>采购类型迅速选品</span>。',
  '点击上方切换你喜欢的品类，我们将根据该品类进行推荐。':
    '点击上方切换你喜欢的品类，我们将根据该品类进行推荐。',
  '如果您有多个店铺可点击这里切换店铺，为不同的店铺采购。THE CKB也会为不同的店铺推荐不同的商品。':
    '如果您有多个店铺可点击这里切换店铺，为不同的店铺采购。THE CKB也会为不同的店铺推荐不同的商品。',
  '你的专属担当根据你的采购习惯，为您甄选的店铺会展示在这里。':
    '你的专属担当根据你的采购习惯，为您甄选的店铺会展示在这里。',
  '此处由系统根据你的采购习惯，为你甄选的店铺会展示在这里。':
    '此处由系统根据你的采购习惯，为你甄选的店铺会展示在这里。',
  '下方为商品的推荐，会根据你的购买习惯更新商品哦！！！':
    '下方为商品的推荐，会根据你的购买习惯更新商品哦！！！',
  '你还没有店铺，快去创建一个你的店铺，用来采购你的商品。':
    '你还没有店铺，快去创建一个你的店铺，用来采购你的商品。',
  跳过: '跳过',
  主钱包: '主钱包',
  子钱包: '子钱包',
  '请输入正确的Amazon sku': '请输入正确的Amazon sku',
  国际发货创建成功: '国际发货创建成功',
  处理中的次品和异常: '处理中的次品和异常',
  不可退货次品: '不可退货次品',
  去查看采购订单: '去查看采购订单',
  资金明细: '资金明细',
  修改商品附加项: '修改商品附加项',
  订单: '订单',
  申请取消成功: '申请取消成功',
  选择同款: '选择同款',
  '是否确认取消国际发货？': '是否确认取消国际发货？',
  '海外仓（fnsku）/asin': '海外仓（fnsku）/asin',
  'Amazon sku/AMAZON商品名称': 'Amazon sku/AMAZON商品名称',
  '搜索Amazon sku/FNSKU/ASIN/SKU': '搜索Amazon sku/FNSKU/ASIN/SKU',
  下单中: '下单中',
  无效的URL: '无效的URL',
  请选择打印模板: '请选择打印模板',
  商品更新: '商品更新',
  最新价格为X元: '最新价格为X元',
  '请输入THE CKB订单编号': '请输入THE CKB订单编号',
  发货标题: '发货标题',
  请设置商品附加项: '请设置商品附加项',
  通过点击关联符合您要求的sku: '通过点击关联符合您要求的sku',
  商品附加项要保存吗: '商品附加项要保存吗',
  签收成功: '签收成功',
  已签收: '已签收',
  请上传箱唛: '请上传箱唛',
  箱唛文件: '箱唛文件',
  上传箱唛: '上传箱唛',
  修改箱唛: '修改箱唛',
  API状态: 'API状态',
  关联商品信息: '关联商品信息',
  出库手续费: '出库手续费',
  编辑组合商品: '编辑组合商品',
  请选择订单: '请选择订单',
  统一编辑发货附加项: '统一编辑发货附加项',
  我的账单: '我的账单',
  待支付总额: '待支付总额',
  '剩余XX天hh:mm:ss自动扣款': '剩余XX天hh:mm:ss自动扣款',
  账单名称: '账单名称',
  待支付: '待支付',
  扣款说明: '扣款说明',
  应付总额: '应付总额',
  钱包金额: '钱包金额',
  主账户账单: '主账户账单',
  子账户账号: '子账户账号',
  '引き落としに成功した場合は、商品を発送いたします。': '',
  '残高不足の原因で引落できなかった場合は、出荷作業を停止して別途支払のご案内をお送りいたします。':
    '',
  'ご入金確認ができ次第、商品を発送いたします。': '',
  '発送の影響を与えるないように、商品発送前にはシステム口座に十分な残高を用意しておいて下さい。':
    '',
  '点击【确定】按钮，系统将自动从余额扣除当前账单<br />应付总额XX元，确定支付吗':
    '点击【确定】按钮，系统将自动从余额扣除当前账单<br/>应付总额XX元，确定支付吗',
  请输入拒绝原因: '请输入拒绝原因',
  请选择清关地址: '请选择清关地址',
  请选择收货地址: '请选择收货地址',
  取消类型: '取消类型',
  客户取消: '客户取消',
  系统取消: '系统取消',
  提交并下载: '提交并下载',
  请求对象姓名: '请求对象姓名',
  请求金额: '请求金额',
  点击下载: '点击下载',
  请求书下载: '请求书下载',
  请确认优先发货信息: '请确认优先发货信息',
  '余额扣费汇率全部以：XX円 = 1元，进行换算，请确认后再进行支付':
    '余额扣费汇率全部以：XX円 = 1元，进行换算，请确认后再进行支付',
  编辑裁剪图片: '编辑裁剪图片',
  名称: '名称',
  实际重量: '实际重量',
  体积重: '体积重',
  长: '长',
  宽: '宽',
  高: '高',
  箱子: '箱子',
  编辑剪切区域和移动图片: '编辑剪切区域和移动图片',
  适合正方形logo: '适合正方形logo',
  适合长方形logo: '适合长方形logo',
  请确认: '【ご確認下さい】',
  '在X系统中追加购买商品的购物车，正在选择中的系统是否符合顾客的意向，请再次确认':
    'Xシステム で買付商品のカート追加が実行されました \n 選択中のシステムがお客様のご意向に沿っているか、再度ご確認下さい',
  d2cb2b系统介绍: 'D2C / B2B システムの補足：',
  系统说明: `D2Cシステム：1点からエンドユーザーへ直送する業務をサポート
  B2Bシステム：在庫を保持し国内EC関連倉庫や自社倉庫へ納品する業務をサポート
  Topメニュー 右側 B2B / D2C アイコンをクリックでシステム切替可能`,
  '系统说明ps(X元Y円)':
    'D2Cシステムは小口配送前提です。1配送単位の商品代金がX元（約Y円）以上の場合、B2Bシステムをご利用下さい',
  // 会员条约: '会員規約',
  使用条约: '利用規約',
  处理结果: '处理结果',
  取消发货任务记录: '取消发货任务记录',
  取消采购记录: '取消采购记录',
  仅限输入英文字符: '仅限输入英文字符',
  无效的邮编: '无效的邮编',
  '输入的支店名格式不正确，请设置1-20位字符':
    '输入的支店名格式不正确，请设置1-20位字符',
  销售额取值范围: '销售额取值范围',
  返现类型: '返现类型',
  返现: '返现',
  返现2: '返现',
  返点: '返点',
  销售额区间: '销售额区间',
  '销售额X%': '销售额X%',
  为期: '为期',
  X个月: 'X个月',
  返现发放时间: '返现发放时间',
  每月X日自动返: '每月X日自动返',
  每季度自动返: '每季度自动返',
  每半年自动返: '每半年自动返',
  充值记录: '充值记录',
  订单是否结算: '订单是否结算',
  未结算: '未结算',
  结算中: '结算中',
  已结算: '已结算',
  结算失败: '结算失败',
  发货取消结果: '发货取消结果',
  查看异常联络处理记录: '查看异常联络处理记录',
  结算时应退款金额: '结算时应退款金额',
  '商品代金，订单结算后解冻至账户余额': '商品代金，订单结算后解冻至账户余额',
  仅限输入英文和数字字符: '仅限输入英文和数字字符',
  取消原因: '取消原因',
  'お客様申請(発送キャンセル済)': 'お客様申請(発送キャンセル済)',
  'お客様申請(発送キャンセル済・在庫保有)':
    'お客様申請(発送キャンセル済・在庫保有)',
  'カラー・サイズ不明': 'カラー・サイズ不明',
  異常注文処理履歴: '異常注文処理履歴',
  在庫切れ: '在庫切れ',
  お客様申請: 'お客様申請',
  予約販売: '予約販売',
  取最小注文ロット数あり消原因: '最小注文ロット数あり',
  '不良品(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)':
    '不良品(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)',
  '不良品(不良品対応設定で「返品返金」ご指定)':
    '不良品(不良品対応設定で「返品返金」ご指定)',
  '在庫切れ(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)':
    '在庫切れ(自動再仕入れ回数上限に達していても、出荷可能良品在庫が足りません)',
  全サイト在庫切れ: '全サイト在庫切れ',
  在庫切れ再発注完了: '在庫切れ再発注完了',
  查看处理详情: '查看处理详情',
  主: '主',
  子: '子',
  月销售额区间: '月销售额区间',
  活动有效期: '活动有效期',
  次品退货退款并付费重拍: '次品退货退款并付费重拍',
  '以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。':
    '以后的商品为次品时，请都默认处理为次品退货退款并付费重拍。',
  '因原商品质量不佳，我们为您重拍时自动寻找了以下新链接，但新链接价格不符合您的预期，请您确认':
    '因原商品质量不佳，我们为您重拍时自动寻找了以下新链接，但新链接价格不符合您的预期，请您确认',
  '因原商品质量不佳，我们为您自动寻找了以下新链接，请您确认是否需要再新链接下重拍':
    '因原商品质量不佳，我们为您自动寻找了以下新链接，请您确认是否需要再新链接下重拍',
  '以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。':
    '以后的商品为次品时，请都默认处理为原商品退货退款并取消商品采购。',
  确认尺码: '确认尺码',
  确认颜色: '确认颜色',
  确认款式: '确认款式',
  全网断货: '全网断货',
  '原商品缺货-推荐同款-价格不符合客户预期':
    '原商品缺货-推荐同款-价格不符合客户预期',
  '原商品缺货-推荐类似款': '原商品缺货-推荐类似款',
  '预售商品-推荐同款商品': '预售商品-推荐同款商品',
  '预售商品-无同款商品推荐': '预售商品-无同款商品推荐',
  '不满足最小起量-推荐同款商品': '不满足最小起量-推荐同款商品',
  '不满足最小起量-无同款商品推荐': '不满足最小起量-无同款商品推荐',
  '更换同款链接-价格不符合客户预期': '更换同款链接-价格不符合客户预期',
  颜色差异: '颜色差异',
  logo差异: 'logo差异',
  '材质、面料差异': '材质、面料差异',
  配件差异: '配件差异',
  商品上有中文: '商品上有中文',
  尺码差异: '尺码差异',
  设计差异: '设计差异',
  其他不良: '其他不良',
  '污渍/斑点/水印': '污渍/斑点/水印',
  破损: '破损',
  线头: '线头',
  接缝不良: '接缝不良',
  抽丝: '抽丝',
  针眼: '针眼',
  霉菌: '霉菌',
  生锈: '生锈',
  商品有中文: '商品有中文',
  纽扣破损: '纽扣破损',
  拉链破损: '拉链破损',
  附属品缺陷: '附属品缺陷',
  有气味: '有气味',
  '原URL缺货，新的URL内商品是X元，请确认':
    '原URL缺货，新的URL内商品是X元，请确认',
  请在我指定的新链接购买: '请在我指定的新链接购买',
  取消商品采购: '取消商品采购',
  '取消商品采购+商品发送': '取消商品采购+商品发送',
  请在我指定的新链接下采购: '请在我指定的新链接下采购',
  '请在THE CKB为我推荐的此链接下采购': '请在THE CKB为我推荐的此链接下采购',
  '可以等待，请继续在原链接采购': '可以等待，请继续在原链接采购',
  '我接受起订量，请继续在原链接采购':
    '我接受起订量，请继续在原链接采购<br/>(多采部分商品无异常上架后将作为库存在THE CKB仓库代为保管，并可匹配其他直发订单发出)',
  '我接受起订量，请继续在原链接采购（多采部分商品无异常上架后将作为库存在THE CKB仓库代为保管，并可匹配其他直发订单发出）':
    '我接受起订量，请继续在原链接采购（多采部分商品无异常上架后将作为库存在THE CKB仓库代为保管，并可匹配其他直发订单发出）',
  '问题不大，我能接受，请当成良品入库': '问题不大，我能接受，请当成良品入库',
  '此问题我不能接受，请依然当成不良品处理':
    '此问题我不能接受，请依然当成不良品处理',
  '我有可能有货的采购链接，请在这个链接再尝试购买':
    '我有可能有货的采购链接，请在这个链接再尝试购买',
  '我等不及，请在我指定的新链接下采购': '我等不及，请在我指定的新链接下采购',
  '我等不及，请在THE CKB为我推荐的此链接下采购':
    '我等不及，请在THE CKB为我推荐的此链接下采购',
  '我不接受起订量，请在我指定的新链接下采购':
    '我不接受起订量，请在我指定的新链接下采购',
  '我不接受起订量，请在THE CKB为我推荐的此链接下采购':
    '我不接受起订量，请在THE CKB为我推荐的此链接下采购',
  'THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购':
    'THE CKB推荐的链接价格等不合适，请在我指定的新链接下采购',
  '此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买':
    '此问题我不能接受，请依然当成不良品处理，并在我指定的新链接购买',
  我还是要继续在原链接采购: '我还是要继续在原链接采购',
  取消商品重拍: '取消商品重拍',
  '取消商品重拍+商品发送': '取消商品重拍+商品发送',
  次品退货退款并取消商品采购: '次品退货退款并取消商品采购',
  '次品退货退款并取消商品采购+商品发送': '次品退货退款并取消商品采购+商品发送',
  批量搜索: '批量搜索',
  '每行一个（支持excel复制黏贴）': '每行一个（支持excel复制黏贴）',
  双击批量搜索: '双击批量搜索',
  确定后将按照新的货代进行发货: '确定后将按照新的货代进行发货',
  '确定后将取消您的国际发货单，您需重新创建':
    '确定后将取消您的国际发货单，您需重新创建',
  关闭后将不再向您店铺同步物流单号: '关闭后将不再向您店铺同步物流单号',
  关闭提醒: '关闭提醒',
  请选择: '選択',
  关闭后将不再向您店铺同步物流单号及订单状态:
    '关闭后将不再向您店铺同步物流单号及订单状态',
  选择类似款: '选择类似款',
  后台导入: '后台导入',
  取消发货: '取消发货',
  '同意一个包裹无法装下商品时，THE CKB将为您拆成多个包裹进行发货':
    '同意一个包裹无法装下商品时，THE CKB将为您拆成多个包裹进行发货',
  '由于该订单商品无法在一个包裹中装下，我们为您拆成了多个包裹进行发货':
    '由于该订单商品无法在一个包裹中装下，我们为您拆成了多个包裹进行发货',
  拆: '拆',
  优: '优',
  下单提醒: '下单提醒',
  下次不再提醒: '下次不再提醒',
  '抱歉，订单正在打包中，不允许修改地址':
    '抱歉，订单正在打包中，不允许修改地址',
  会员规则变更通知: '会员规则变更通知',
  '尊敬的用户，THE CKB团队经过谨慎考虑，为了更好的为用户提供服务，决定在经历了一段时间的免费运营后，于2023/1/11开始只对付费会员提供服务。':
    '尊敬的用户，THE CKB团队经过谨慎考虑，为了更好的为用户提供服务，决定在经历了一段时间的免费运营后，于2023/1/11开始只对付费会员提供服务。',
  '您也不用担心，您是陪伴我们成长的首批用户，我们已为您自动升级到新会员，并且免费送您会员到1月31日（原价9800日元/月)！赶快去试用体验吧！':
    '您也不用担心，您是陪伴我们成长的首批用户，我们已为您自动升级到新会员，并且免费送您会员到1月31日（原价9800日元/月)！赶快去试用体验吧！',
  '免费送您会员到1月31日（原价9800日元/月)':
    '免费送您会员到1月31日（原价9800日元/月)',
  '到期后会员将失效，将无法享受下单服务，欢迎随时充值新会员。':
    '到期后会员将失效，将无法享受下单服务，欢迎随时充值新会员。',
  新会员权益介绍: '新会员权益介绍',
  开通新会员: '开通新会员',
  查看新会员: '查看新会员',
  '开通会员，立享下单代买服务。请联系主账号开通。':
    '开通会员，立享下单代买服务。请联系主账号开通。',
  '开通会员，立享下单代买服务': '开通会员，立享下单代买服务',
  '开通会员，即可享受下单代买服务。': '开通会员，即可享受下单代买服务。',
  '请联系主账号开通。': '请联系主账号开通。',
  '即可享受下单代买服务。': '即可享受下单代买服务。',
  能够在中国找到丰富的供应商: '能够在中国找到丰富的供应商',
  '按照日本质量标准进行检验（隶属于日本公司）':
    '按照日本质量标准进行检验（隶属于日本公司）',
  '最低国际运费保证，可运往23个国家/地区':
    '最低国际运费保证，可运往23个国家/地区',
  可靠的支持和即时的客户服务: '可靠的支持和即时的客户服务',
  会员中心: '会员中心',
  我的会员: '我的会员',
  '有效期：': '有效期：',
  已失去会員: '已失去会員',
  未登録: '未登録',
  未登录: '未登录',
  加入新会员: '加入新会员',
  '会员等级变更！': '会员等级变更！',
  您当前的会员等级已变更为: '您当前的会员等级已变更为',
  立即享用会员: '立即享用会员',
  '您的会员已到期！': '您的会员已到期！',
  '您当前的会员已到期，为了不影响正常下单和使用，请及时开通哦！（不影响历史订单集账户余额充值）':
    '您当前的会员已到期，为了不影响正常下单和使用，请及时开通哦！（不影响历史订单集账户余额充值）',
  查看会员: '查看会员',
  联系我们: '联系我们',
  // 新会员
  'THE CKB会员，为您的买卖生活提供一切所需。':
    'THE CKB会员，为您的买卖生活提供一切所需。',
  入会优享超多服务: '入会优享超多服务',
  开通会员: '开通会员',
  有效期至: '有效期至',
  自动续费已开启: '自动续费已开启',
  成为: '成为', // xxxx 成为xxx会员
  去续费: '去续费',
  当前自动续费不可开启: '当前自动续费不可开启',
  '您在持有预充会员【XX】期间，暂不可开启自动续费。在该预充会员正式开启后，我们会自动为您开启会员的自动续费，敬请谅解。':
    '您在持有预充会员【XX】期间，暂不可开启自动续费。在该预充会员正式开启后，我们会自动为您开启会员的自动续费，敬请谅解。',
  知道了: '知道了',
  '请及时关闭PayPal账户内不需要的自动续费，如未关闭，我们会将这笔钱充值到您的余额，可能需要您承担部分手续费。':
    '请及时关闭PayPal账户内不需要的自动续费，如未关闭，我们会将这笔钱充值到您的余额，可能需要您承担部分手续费。',
  关闭PayPal自动续费教程: '关闭PayPal自动续费教程',
  续费提示: '续费提示',
  '续费后，会在XX开始自动延长YY时间': '续费后，会在XX开始自动延长YY时间',
  '检测到您当前有T1至T2的预充会员，续费成功后，会取消原来预充的会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。':
    '检测到您当前有T1至T2的预充会员，续费成功后，会取消原来预充的会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。',
  升舱提示: '升舱提示',
  '您当前为V1，想开通V2，您想选择何时生效？开通成功后，选择将不可更改':
    '您当前为V1，想开通V2，您想选择何时生效？开通成功后，选择将不可更改',
  '检测到您当前有T1至T2的预充会员，降仓成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。':
    '检测到您当前有T1至T2的预充会员，降仓成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>。',
  降舱提示: '降舱提示',
  '您当前为V1，想开通V2，为保障您当前的会员权益，会等原会员套餐到期（TT）后开始实行降仓会员，是否要进行降仓？':
    '您当前为V1，想开通V2，为保障您当前的会员权益，会等原会员套餐到期（TT）后开始实行降仓会员，是否要进行降仓？',
  '续费后，会在T开始自动延长V时间': '续费后，会在T开始自动延长V时间',
  '您当前为V1，充值V2，您可以选择立即生效或者当前会员到期之后生效。开通成功后，选择将不可更改':
    '您当前为V1，充值V2，您可以选择立即生效或者当前会员到期之后生效。开通成功后，选择将不可更改',
  '检测到您当前有2段会员，升舱成功后，会取消当前会员和预充会员，<span style="color:#EB4545;">钱款不予退还</span>。':
    '检测到您当前有2段会员，升舱成功后，会取消当前会员和预充会员，<span style="color:#EB4545;">钱款不予退还</span>。',
  '检测到您当前有T1至T2的预充会员，升舱成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>':
    '检测到您当前有T1至T2的预充会员，升舱成功后，会取消预充会员，预充会员的<span style="color:#EB4545;">钱款不予退还</span>',
  '您当前为V1，充值V2，您想选择立即生效还是老会员到期之后生效？开通成功后，选择将不可更改':
    '您当前为V1，充值V2，您想选择立即生效还是老会员到期之后生效？开通成功后，选择将不可更改',
  立即生效: '立即生效',
  开始生效: '开始生效', // XXX开始生效
  定时升舱: '定时升舱',
  利用期间: '利用期间',
  '%off': '%割引',
  '折合X円/月': '折合X円/月',
  已成功开通预充会员: '已成功开通预充会员',
  已成功开通会员: '已成功开通会员',
  '已为您开启预充会员V，有效期为Y': '已为您开启预充会员V，有效期为Y',
  '已为您开启V，有效期为Y': '已为您开启V，有效期为Y',
  '为了不影响您的后续使用，请保持PayPal内开启自动续费。':
    '为了不影响您的后续使用，请保持PayPal内开启自动续费。',
  已优惠: '已优惠:X',
  确认协议并立即支付: '确认协议并立即支付',
  请阅读: '请阅读',
  会员服务协议: '会员服务协议',
  及: '及',
  自动续费服务规则: '自动续费服务规则', // 整句话 请阅读“会员服务协议”及“自动续费服务规则”
  高级会员专享服务: '高级会员专享服务',
  '如需开通商务舱或头等舱会员，请先用line扫描右侧二维码联系我们，获取专属咨询服务。':
    '如需开通商务舱或头等舱会员，请先用line扫描右侧二维码联系我们，获取专属咨询服务。',
  恭喜成功开通: '恭喜成功开通',
  '为了更好地帮您履行下单履约，您需要提前填写以下信息。':
    '为了更好地帮您履行下单履约，您需要提前填写以下信息。',
  添加店铺: '添加店铺',
  采购设置: '采购设置',
  国际配送设置: '国际配送设置',
  暂不设置: '暂不设置',
  保存设置: '保存设置',
  请填写完成国际配送设置: '请填写完成国际配送设置',
  请填写完成采购设置: '请填写完成采购设置',
  请填写完成店铺信息: '请填写完成店铺信息',
  去开通: '去开通',
  是否要关闭自动续费: '是否要关闭自动续费',
  '关闭自动续费后，您的V将于T到期。关闭后会影响您后续的正常使用，请谨慎关闭。是否现在关闭？':
    '关闭自动续费后，您的V将于T到期。关闭后会影响您后续的正常使用，请谨慎关闭。是否现在关闭？',
  '为了能正常关闭自动续费，请务必前往paypal关闭自动续费。':
    '为了能正常关闭自动续费，请务必前往paypal关闭自动续费。',
  '已为您开启V自动续费，记得保持余额充足。':
    '已为您开启V自动续费，记得保持余额充足。',
  '为了能正常打开自动续费，请务必前往PayPal开启自动续费。':
    '为了能正常打开自动续费，请务必前往PayPal开启自动续费。',
  支付金额: '支付金额',
  '尊敬的用户，您需办理会员后，方可下单，请联系主账号办理':
    '尊敬的用户，您需办理会员后，方可下单，请联系主账号办理',
  '尊敬的用户，您需办理会员后，方可下单':
    '尊敬的用户，您需办理会员后，方可下单',
  办理会员: '办理会员',
  '尊敬的用户，您于T变更为非会员用户，我们已发站内信告知您：开启自动同步下单功能及按钮已关闭（变为非会员后，不影响历史订单及账户余额提现）':
    '尊敬的用户，您于T变更为非会员用户，我们已发站内信告知您：开启自动同步下单功能及按钮已关闭（变为非会员后，不影响历史订单及账户余额提现）',
  '尊敬的用户，您需办理会员成功后，方可同订单数据':
    '尊敬的用户，您需办理会员成功后，方可同订单数据',
  '尊敬的用户，您需办理会员成功后，方可开启自动同步下单，请联系主账号办理':
    '尊敬的用户，您需办理会员成功后，方可开启自动同步下单，请联系主账号办理',
  '尊敬的用户，您需办理会员成功后，方可开启自动同步下单':
    '尊敬的用户，您需办理会员成功后，方可开启自动同步下单',
  '尊敬的用户，您于2022.02.10 13:57变更为非会员用户，已授权的API被禁用，需办理会员成功后，方可同步订单数据，请联系主账号办理':
    '尊敬的用户，您于2022.02.10 13:57变更为非会员用户，已授权的API被禁用，需办理会员成功后，方可同步订单数据，请联系主账号办理',
  '尊敬的用户，您需办理会员后，方可授权绑定子店铺，请联系主账号办理':
    '尊敬的用户，您需办理会员后，方可授权绑定子店铺，，请联系主账号办理',
  '尊敬的用户，您需办理会员成功后，方可授权绑定子店铺':
    '尊敬的用户，您需办理会员成功后，方可授权绑定子店铺',
  授权店铺API绑定变更: '授权店铺API绑定变更',
  '尊敬的用户，您于T变更为非会员用户，已授权店铺绑定的API变更为禁用状态（不影响历史订单及账户余额提现）':
    '尊敬的用户，您于T变更为非会员用户，已授权店铺绑定的API变更为禁用状态（不影响历史订单及账户余额提现）',
  '已授权（禁用）': '已授权（禁用）',
  '円/月': '円/月',
  '/月': '{currency}/月',
  '{currency}/月': '{currency}/月',
  绑定信用卡支付: '绑定信用卡支付',
  你还没有绑定信用卡: '你还没有绑定信用卡',
  有効期限: '有効期限',
  请选择信用卡: '请选择信用卡',
  '是否删除信用卡？': '是否删除信用卡？',
  信用卡卡号: '信用卡卡号',
  信用卡安全码: '信用卡安全码',
  仅限数字: '仅限数字',
  '仅限输入3-4位数字安全码': '仅限输入3-4位数字安全码',
  '仅限数字，例：05/2022': '仅限数字，例：05/2022',
  请检查卡信息是否有误: '请检查卡信息是否有误',
  '支付失败，请重新操作！': '支付失败，请重新操作！',
  paypal信用卡: 'paypal信用卡',
  充值失败: '充值失败',
  会费: '会费',
  最低: '最低',
  请联系主账号更改: '请联系主账号更改',
  已为您开启自动续费: '已为您开启自动续费',
  已失去会员: '已失去会员',
  未入会: '未入会',
  设为默认支付方式: '设为默认支付方式',
  支付失败: '支付失败',
  '余额不足，请先充值余额后重试。': '余额不足，请先充值余额后重试。',
  每次询问我处理次品方式: '每次询问我处理次品方式',
  PayPal加载中: 'PayPal加载中',
  '余额不足，请先绑定店铺后充值，再重试':
    '余额不足，请先绑定店铺后充值，再重试',
  '信用卡-由PayPal提供，支持Visa、MasterCard、AMEX、JCB等类型':
    '信用卡-由PayPal提供，支持Visa、MasterCard、AMEX、JCB等类型',
  会员开通记录: '会员开通记录',
  活动赠送: '活动赠送',
  自动续费: '自动续费',
  自动续费2: '自动续费',
  开通失败: '开通失败',
  开通成功: '开通成功',
  待生效: '待生效',
  会员套餐: '会员套餐',
  '支付价格（日元）': '支付价格',
  会员有效期: '会员有效期',
  导出记录: '导出记录',
  会员订单编号: '会员订单编号',
  '该地区不支持访问，请求地址': '该地区不支持访问，请求地址',
  用户IP: '用户IP',
  点这里给我们发送错误报告: '点这里给我们发送错误报告',
  类型2: '类型',
  '如果您现在更改会员计划，您当前的会员资格将失效。请注意，会员费不可退还。':
    '如果您现在更改会员计划，您当前的会员资格将失效。请注意，<span style="color:#EB4545;">会员费不可退还。<span/>',
  开通会员2: '开通会员',
  状态2: '状态',
  银行卡便捷支付: '银行卡便捷支付',
  '线下汇款至我们指定的银行账户，点此查看':
    '线下汇款至我们指定的银行账户，点此查看',
  收款账户信息: '收款账户信息',
  绑定您的支付行信息: '绑定您的支付行信息',
  提交支付信息: '提交支付信息',
  绑定银行卡信息: '绑定银行卡信息',
  '系统确认中的状态是指银行到账通知时间存在差异，如超过3天状态未变更，请先联系当地银行确认打款是否成功，再联系客服处理':
    '系统确认中的状态是指银行到账通知时间存在差异，如超过3天状态未变更，请先联系当地银行确认打款是否成功，再联系客服处理',
  银行名称2: '银行名称',
  银行账号2: '银行账号',
  支店名2: '支店名',
  支店号: '支店号',
  账户持有人: '账户持有人',
  设为默认支付方式2: '设为默认支付方式',
  '系统确认中~预计1-3个工作日到账，后续可在充值记录查看资金入账情况！':
    '系统确认中~<br/>预计1-3个工作日到账，后续可在充值记录查看资金入账情况！',
  '复制收款银行信息，去线下银行转账至我们的收款银行':
    '复制收款银行信息，去线下银行转账至我们的收款银行',
  '线下银行转账成功后，您可以在这里绑定您自己的银行卡信息':
    '线下银行转账成功后，您可以在这里绑定您自己的银行卡信息',
  '输入金额，点击“确定”按钮，提交支付信息':
    '输入金额，点击“确定”按钮，提交支付信息',
  '请先确认线下汇款成功后再提交，否则审核会被拒绝':
    '请先确认线下汇款成功后再提交，否则审核会被拒绝',
  '请输入1-20位银行名称': '请输入1-20位银行名称',
  '请输入1-20位数字银行账号': '请输入1-20位数字银行账号',
  '请输入1-20位支店名': '请输入1-20位支店名',
  请输入3位支店号: '请输入3位支店号',
  '请输入1-20位账户持有人': '请输入1-20位账户持有人',
  不可代购: '不可代购',
  '输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写':
    '输入的密码格式不正确，请设置6-32个字符，字母和数字的组合，字母区分大小写',
  '是否修改密码？': '是否修改密码？',
  '系统检测到您当前的密码过于简单，存在安全风险，建议您修改密码。':
    '系统检测到您当前的密码过于简单，存在安全风险，建议您修改密码。',
  '注册或登录后，将为您推荐更多个性化内容。':
    '注册或登录后，将为您推荐更多个性化内容。',
  删除成功: '删除成功',
  完成以下配置才可使用表格导入创建订单功能:
    '完成以下配置才可使用表格导入创建订单功能',
  默认商品附加项配置: '默认商品附加项配置',
  默认发货附加项配置: '默认发货附加项配置',
  默认国际物流配置: '默认国际物流配置',
  前往配置: '前往配置',
  注意事项: '注意事项',
  '1.表格数据最多为1000行，超过请分多个表格导入':
    '1.表格数据最多为1000行，超过请分多个表格导入',
  '1.表格数据最多为200行，超过请分多个表格导入':
    '1.表格数据最多为200行，超过请分多个表格导入',
  '2.仅支持.xlsx、.xls文件，且小于20M': '2.仅支持.xlsx、.xls文件，且小于20M',
  '3.导入成功后，请前往「待付款」，进行付款后完成下单':
    '3.导入成功后，请前往「待付款」，进行付款后完成下单',
  订单创建中: '订单创建中',
  下单失败提示: '下单失败提示',
  本次导入成功X个订单: '本次导入成功X个订单',
  失败X个订单: '失败X个订单',
  失败订单请重新导入: '失败订单请重新导入',
  失败订单下载: '失败订单下载',
  我已知晓: '我已知晓',
  下载: '下载',
  // 表格字段
  order_客户订单号: 'お客様注文番号',
  'order_THE CKB SKU': 'THE CKB SKU',
  order_数量: '数量',
  order_收件人姓名: '受取人',
  order_联系电话: '電話番号',
  order_都道府县: '都道府県',
  order_市: '市',
  order_详细地址: '詳細住所',
  order_邮编: '郵便番号',
  'good_THE CKB SKU': 'THE CKB SKU',
  good_数量: '数量',
  '表格数据最多为1000行，请分多个表格导入':
    '表格数据最多为1000行，请分多个表格导入',
  '表格数据最多为100行，请分多个表格导入':
    '表格数据最多为100行，请分多个表格导入',
  客户订单号不能为空: '客户订单号不能为空',
  客户订单号最长为100个字符: '客户订单号最长为100个字符',
  商品SKU不能为空: '商品SKU不能为空',
  '请输入6~100个字符的商品SKU': '请输入6~100个字符的商品SKU',
  '第X行，同一个客户订单号SKU有且仅能有一行':
    '第X行，同一个客户订单号SKU有且仅能有一行',
  请输入7位数字的邮编: '请输入7位数字的邮编',
  请勾选订单: '请勾选订单',
  表格下单: '表格下单',
  表格导入创建订单: '表格导入创建订单',
  表格导入中: '表格导入中',
  表格导入创建商品: '表格导入创建商品',
  批量付款: '批量付款',
  客户订单号: '客户订单号',
  '商品总额(￥)': '商品总额(￥)',
  '附加项总额(￥)': '附加项总额(￥)',
  '总计(￥)': '总计(￥)',
  商品属性: '商品属性',
  '单价(￥)': '单价(￥)',
  '附加项金额(￥)': '附加项金额(￥)',
  '小计(￥)': '小计(￥)',
  确认订单信息: '确认订单信息',
  商品创建中: '商品创建中',
  请勿上传空文件: '请勿上传空文件',
  数量不能为空: '数量不能为空',
  请输入大于等于1的整数: '请输入大于等于1的整数',
  收件人姓名不能为空2: '收件人姓名不能为空',
  '请输入1-50个字符的商品SKU': '请输入1-50个字符的商品SKU',
  联系方式不能为空: '联系方式不能为空',
  '请输入8-11字符的联系方式': '请输入8-11字符的联系方式',
  都道府县不能为空2: '都道府县不能为空',
  '请输入1-50字符的都道府县': '请输入1-50字符的都道府县',
  '请输入1-50字符的市': '请输入1-50字符的市',
  都道府县与市不匹配: '都道府县与市不匹配',
  详细地址不能为空2: '详细地址不能为空',
  邮编不能为空2: '邮编不能为空',
  '请输入1-50个字符的收件人姓名': '请输入1-50个字符的收件人姓名',
  '相同订单下，收件人信息与第X行不一致': '相同订单下，收件人信息与第X行不一致',
  '订单创建成功，完成付款后下单成功': '订单创建成功，完成付款后下单成功',
  第X行: '第X行',
  数据不完整: '数据不完整',
  数量需为大于0的整数: '数量需为大于0的整数',
  第X行SKU重复: '第X行SKU重复',
  上传失败请重试: '上传失败请重试',
  客户订单号最长为32个字符: '客户订单号最长为32个字符',
  没有该都道府县: '没有该都道府县',
  请上传文件: '请上传文件',
  '文件大于20M,请重新上传': '文件大于20M,请重新上传',
  表格导入商品: '表格导入商品',
  '请输入1-200字符的详细地址': '请输入1-200字符的详细地址',
  删除成功2: '删除成功2',
  '货物发出去之后不要在亚马逊后台再打开这个补货计划，避免调用api失败':
    '货物发出去之后不要在亚马逊后台再打开这个补货计划，避免调用api失败',
  '订单读取中，预计需要1-3分钟，请稍后刷新页面查看读取结果':
    '订单读取中，预计需要1-3分钟，请稍后刷新页面查看读取结果',
  处理详情: '处理详情',
  文件大小不超过10M: '文件大小不超过10M',
  'PayPal加载中，请稍等': 'PayPal加载中，请稍等',
  由PayPal提供服务: '由PayPal提供服务',
  '请求超时，请稍后重试': '请求超时，请稍后重试',
  '预计到账CNY：X元': '预计到账CNY：X元',
  '支付中，请稍等': '支付中，请稍等',
  '您填写的信息受到加密保护，请安心填写':
    '您填写的信息受到加密保护，请安心填写',
  电话: '电话',
  再试一次: '再试一次',
  充值撤回: '充值撤回',
  请选择银行卡: '请选择银行卡',
  已失效: '已失效',
  已下架: '已下架',
  商品不存在: '商品不存在',
  '存在已失效商品，请调整商品': '存在已失效商品，请调整商品',
  '存在已下架商品，请调整商品': '存在已下架商品，请调整商品',
  '存在库存过低商品，请调整发货量或及时补充库存':
    '存在库存过低商品，请调整发货量或及时补充库存',
  '多个商品有异常，请重新调整商品': '多个商品有异常，请重新调整商品',
  '商品已下架，请调整商品或发货量': '商品已下架，请调整商品或发货量',
  '商品已失效，请调整商品或发货量': '商品已失效，请调整商品或发货量',
  库存不足: '库存不足',
  组合或oem商品不允许编辑尺码变更: '组合或oem商品不允许编辑尺码变更',
  请创建关联关系后再选择: '请创建关联关系后再选择',
  请补充手机号信息: '请补充手机号信息',
  '为了更好的为您服务，我们建议您补充手机号信息':
    '为了更好的为您服务，我们建议您补充手机号信息',
  不写区号: '无',
  补充手机号: '补充手机号',
  '活动赠送(推广联盟)': '活动赠送(推广联盟)',
  温馨提示: '温馨提示',
  去升级: '去升级',
  暂不升级: '暂不升级',
  '当前提交的订单商品数量达X件，升级标准舱预计本单可节省Y元手续费(入库手续费&出库手续费)，是否升级后再下单？':
    '当前提交的订单商品数量达X件，<span style="color:#EB4545;">升级标准舱</span>预计本单<span style="color:#EB4545">可节省Y元</span>手续费(入库手续费&出库手续费)，是否升级后再下单？',
  '出库手续费(预估)': '出库手续费(预估)',
  '入库手续费(预估)': '入库手续费(预估)',
  '可节省手续费合计(预估)': '可节省手续费合计(预估)：X元',
  件1: '件',
  收件人姓名: '收件人姓名',
  '订单中所有商品的状态为“已检品”或“已取消”时，清算订单':
    '订单中所有商品的状态为“已检品”或“已取消”时，清算订单',
  是否有异常联络: '是否有异常联络',
  使用客户商品sku: '使用客户商品sku',
  去找同款: '去找同款',
  待付款提醒: '待付款提醒',
  '您有{num}笔订单待付款，请及时支付，否则会影响订单履约':
    '您有{num}笔订单待付款，请及时支付，否则会影响订单履约',
  余额不足: '余额不足',
  分期付款: '分期付款',
  确定支付: '确定支付',
  已支付: '已支付',
  本期支付: '本期支付',
  订单总金额: '订单总金额',
  '当前账户余额不足，请先充值。': '当前账户余额不足，请先充值。',
  支付信息: '支付信息',
  已支付金额: '已支付金额',
  待支付金额: '待支付金额',
  新增寻源任务: '新增寻源任务',
  国际发货详情2: '国际发货详情',
  资金明细2: '资金明细',
  押金: '押金',
  已返还: '已返还',
  未返金: '未返金',
  商品代金: '商品代金',
  未确认: '未确认',
  国内运费2: '国内运费',
  代购手续费: '代购手续费',
  '商品代金(押金)': '商品代金(押金)',
  '商品附加项(押金)': '商品附加项(押金)',
  返金: '返金',
  '商品附加项(返品不可不良品)': '商品附加项(返品不可不良品)',
  国内运费退款: '国内运费退款',
  既成品采购费: '既成品采购费',
  市场商品采购费: '市场商品采购费',
  次品重买: '次品重买',
  次品退货2: '次品退货',
  商品组合: '商品组合',
  入库费: '入库费',
  出库费: '出库费',
  '订单仍在进行中，当前产生的费用并不是最终实际费用':
    '订单仍在进行中，当前产生的费用并不是最终实际费用',
  我司请求重量: '我司请求重量',
  运输公司请求重量: '运输公司请求重量',
  '※运输公司称重比我司称重的情况下，需要补扣差额。':
    '※运输公司称重比我司称重的情况下，需要补扣差额。',
  快递公司: '快递公司',
  发货附加项2: '发货附加项',
  重量差补扣: '重量差补扣',
  国际运费补扣总和: '国际运费补扣总和',
  退款: '退款',
  国际发货合计额: '国际发货合计额',
  '金额（元）': '金额（元）',
  偏远地区费: '偏远地区费',
  箱标: '箱标',
  补扣: '补扣',
  超长费: '超长费',
  改派费: '改派费',
  扣件费: '扣件费',
  退件费: '退件费',
  销毁费: '销毁费',
  仓储费: '仓储费',
  关税: '关税',
  特殊处理费: '特殊处理费',
  次品退款: '次品退款',
  订单已清算完毕: '订单已清算完毕',
  下载收据: '下载收据',
  '商品代金・商品附加项': '商品代金・商品附加项',
  '国内运费 · 代购手续费': '国内运费 · 代购手续费',
  请选择2: '请选择',
  本期支付金额: '本期支付金额',
  '订单商品代金(预估)': '订单商品代金(预估)',
  本次实付商品代金: '本次实付商品代金',
  待支付商品代金尾款: '待支付商品代金尾款',
  '订单商品附加项(预估)': '订单商品附加项(预估)',
  '订单本次实付金额(预估)': '订单本次实付金额(预估)',
  '订单已生成，部分订单支付失败，': '订单已生成，部分订单支付失败，',
  '订单已生成，生成订单信息如下请随时关注订单动态':
    '订单已生成，生成订单信息如下请随时关注订单动态',
  同一个寻源单不能同时下大货和样品: '同一个寻源单不能同时下大货和样品',
  同一个订单只能存在一个OEM商品下单: '同一个订单只能存在一个OEM商品下单',
  订单应冻结金额: '订单应冻结金额',
  注册信息隐私说明: '注册信息隐私说明',
  'X期商品代金(押金)': 'X期商品代金(押金)',
  X期金额: 'X期金额',
  本期冻结总价: '本期冻结总价',
  请输入中文: '请输入中文',
  '注册成功后国家/地区无法更改，请谨慎选择':
    '注册成功后国家/地区无法更改，请谨慎选择',
  '此单包含X种运输方式，生成了Y个国际发货单':
    '此单包含<span style="color:var(--fcolor)">X</span>种运输方式，生成了<span style="color:var(--fcolor)">Y</span>个国际发货单',
  变更理由: '变更理由',
  涉及药事法: '涉及药事法',
  涉及食品法: '涉及食品法',
  带电池: '带电池',
  木制品: '木制品',
  侵权产品: '侵权产品',
  '粉末，液体，以及易燃易爆物品': '粉末，液体，以及易燃易爆物品',
  '武器配件，管制刀具等': '武器配件，管制刀具等',
  动植物产品: '动植物产品',
  不满足发货重量要求: '不满足发货重量要求',
  价格过高: '价格过高',
  未发货2: '未发货',
  已发货2: '已发货',
  直播中: '直播中',
  去预约: '去预约',
  请购买会员后观看直播: '请购买会员后观看直播',
  我已知晓1: '我已知晓',
  开通会员1: '开通会员',
  直播价: '直播价',
  钱包余额不足: '钱包余额不足',
  'PRO会员尊享：常规权益+PRO追加权益，查看':
    'PRO会员尊享：常规权益+PRO追加权益，查看',
  常规权益: '常规权益',
  '1688原价': '1688原价',
  '当前会员等级享无水印图片{X}次/月，剩余{Y}次':
    '当前会员等级享无水印图片{X}次/月，剩余{Y}次。',
  '※无水印图片次数说明': '※无水印图片次数说明',
  无限使用: '无限使用',
  '{X}次/月': '{X}次/月',
  升级会员享无限次: '升级会员享无限次',
  '抱歉，您的无水印次数已达上限，升级会员享受无限次。':
    '抱歉，您的无水印次数已达上限，升级会员享受无限次。',
  '您当前的会员等级，可享无限次“无水印”图片下载。':
    '您当前的会员等级，可享无限次“无水印”图片下载。',
  无水印: '无水印',
  有水印: '有水印',
  同款商品: '同款商品',
  暂无相关搜索结果: '暂无相关搜索结果',
  去站外搜更多: '去站外搜更多',
  重新上传图片搜索: '重新上传图片搜索',
  '监测到您当前尚未安装KAERU插件，【站外搜】功能需要配合KAERU插件才可正常使用哦。':
    '监测到您当前尚未安装KAERU插件，【站外搜】功能需要配合KAERU插件才可正常使用哦。',
  '什么是KAERU插件？': '什么是KAERU插件？',
  去安装: '去安装',
  暂不安装: '暂不安装',
  '1688严选': '1688严选',
  去1688严选搜: '去1688严选搜',
  查看1688官方精选供应商商品: '查看1688官方精选供应商商品',
  只看精选会员折扣价: '只看精选会员折扣价',
  '使用插件，您可以将1688等平台产品直接添加到THE CKB购物车中。':
    '使用插件，您可以将1688等平台产品直接添加到THE CKB购物车中。',
  // 三方登录
  '已经注册的邮件地址。请登录，进行{A}关联。':
    '已经注册的邮件地址。请登录{A}进行关联。',
  '国家/地区': '国家/地区',
  同意用户协议: '同意用户协议',
  首页: '首页',
  登录名: '登录名',
  '注册成功后登录名将无法更改。': '注册成功后登录名将无法更改。',
  '6-32个字符': '6-32个字符',
  '字母和数字的组合(字母区分大小写)': '字母和数字的组合(字母区分大小写)',
  邀请码: '邀请码',
  返回上一步: '返回上一步',
  注册完成: '注册完成',
  '登录名/邮箱': '登录名/邮箱',
  注册并绑定您的CKB账户: '注册并绑定您的CKB账户',
  '只需绑定一次，后续可用{platform}直接登录':
    '只需绑定一次，后续可用{platform}直接登录',
  '已有CKB账户，去【登录并绑定】': '已有CKB账户，去<span>【登录并绑定】</span>',
  邮箱登录: '邮箱登录',
  确认绑定: '确认绑定',
  '还没有CKB账户，现在去【注册并绑定】':
    '还没有CKB账户，现在去<span>【注册并绑定】</span>',
  三方登录管理: '三方登录管理',
  '是否解绑{A}账户': '是否解绑{A}账户',
  绑定成功: '绑定成功',
  绑定失败: '绑定失败',
  绑定您的CKB账户: '绑定您的CKB账户',
  '您的账户已被其他账号绑定，无法绑定当前账号。':
    '您的账户已被其他账号绑定，无法绑定当前账号。',
  授权回调中: '授权回调中',
  授权成功: '授权成功',
  '我还没有CKB账户，现在': '我还没有CKB账户，现在',
  必须: '必须',
  店铺余额: '店铺余额',
  '根据韩国海关的要求选择附加项：': '根据韩国海关的要求选择附加项：',
  '最终选择用企业通关来国际发货时-': '最终选择用企业通关来国际发货时-',
  '如果是纺织品（例：衣服/被子等）': '如果是纺织品（例：衣服/被子等）',
  '在下单时一定需要选择水洗标制作和水洗标缝制服务！':
    '<span style="color:#D81515">在下单时一定需要选择水洗标制作和水洗标缝制服务！</span>',
  '如果是杂货（例：发卡/文具等）': '如果是杂货（例：发卡/文具等）',
  '一定在发货时选择贴原产地标服务！':
    '<span style="color:#D81515">一定在发货时选择贴原产地标服务！</span>',
  // 1688国家货盘---start
  手机验证码: '手机验证码',
  注册成为1688官方认证账号: '注册成为1688官方认证账号',
  手机号验证码登录: '手机号验证码登录',
  邮箱验证码登录: '邮箱验证码登录',
  使用手机号找回密码: '使用手机号找回密码',
  使用邮箱找回密码: '使用邮箱找回密码',
  手机号验证码: '手机号验证码',
  国家专属搜索和专属货盘: '国家专属搜索和专属货盘',
  '搜索1688国家专属严选货盘 所有产品品质保障':
    '搜索1688国家专属严选货盘 所有产品品质保障',
  'THE CKB为1688日本官方专属运营商': 'THE CKB为1688日本官方专属运营商',
  'THE CKB为1688日本官方专属代采商': 'THE CKB为1688日本官方专属代采商',
  了解国家专属搜索框和普通搜索框的区别: '了解国家专属搜索框和普通搜索框的区别',
  查看1688国家货盘商品: '查看1688国家货盘商品',
  '1688日本官方合作伙伴': '1688日本官方合作伙伴',
  注册1688官方认证账号: '注册1688官方认证账号',
  立即注册: '立即注册',
  履约质量: '履约质量',
  综合体验: '综合体验',
  综合体验分: '综合体验分',
  认证工厂: '认证工厂',
  '24小时揽收率': '24小时揽收率',
  '48小时揽收率': '48小时揽收率',
  服务保障: '服务保障',
  当日发货: '当日发货',
  对搜索结果是否满意: '对搜索结果是否满意',
  满意: '满意',
  不满意: '不满意',
  '请说说你的不满意的点，以便我们改进': '请说说你的不满意的点，以便我们改进',
  感谢您的反馈: '感谢您的反馈',
  感谢您的宝贵意见: '感谢您的宝贵意见',
  去1688国家专属货盘搜索: '去1688国家专属货盘搜索',
  '1688国家货盘': '1688国家货盘',
  复购率: '复购率从高到低',

  'THE CKB用户协议': 'THE CKB用户协议',
  和: '和',
  '1688用户协议': '1688用户协议',
  '新密码（用于确认）': '新密码（用于确认）',
  输入手机号: '输入手机号',
  请重新输入正确的手机号: '请重新输入正确的手机号',
  下面的检索结果都是1688严选商品: '下面的检索结果都是1688严选商品',
  '请说说你的不满意的点，以便我们改进：':
    '请说说你的不满意的点，以便我们改进：',
  クリア: 'クリア',
  この条件で検索する: 'この条件で検索する',
  よいです: 'よいです',
  よくないです: 'よくないです',
  '検索した情報はどうですか？': '検索した情報はどうですか？',
  下記の検索結果はすべて1688公式優良認定商品になります:
    '下記の検索結果はすべて1688公式優良認定商品になります',
  '『1688公式優良認定商品特徴』': '『1688公式優良認定商品特徴』',
  '· 高速発送    · 特価商品    · 厳選品質':
    '· 高速発送    · 特価商品    · 厳選品質',
  // 价格:'价格',
  // 1688国家货盘---end
  '如果不能确认请联系页面右方的客服中心服务！':
    '如果不能确认请联系页面右方的客服中心服务！',
  // 为了防止冲突，最后一行不要修改，添加的翻译写在之上
  折扣价: '折扣价',
  未授权_: '未授权',
  已授权_: '已授权',
  已失效_: '已失效',
  品牌集: '品牌集',
  查看更多_: '查看更多',
  '请输入主营类目、品牌名称或风格': '请输入主营类目、品牌名称或风格',
  什么是品牌集: '什么是品牌集',
  主营类目: '主营类目',
  品牌_: '品牌',
  风格_: '风格',
  采购市场_: '采购市场',
  可授权形式: '可授权形式',
  全部_: '全部',
  普通授权: '普通授权',
  独家授权: '独家授权',
  均价范围: '均价范围',
  自定义_: '自定义',
  已授权__: '已授权',
  申请中: '申请中',
  未授权__: '未授权',
  已失效1: '已失效',
  地址: '地址',
  平均客单价: '平均客单价',
  授权类型: '授权类型',
  品牌风格: '品牌风格',
  产品理念: '产品理念',
  品牌说明书: '品牌说明书',
  授权申请: '授权申请',
  收起筛选: '收起筛选',
  展开更多: '展开更多',
  '距离授权到期仅剩{day}天': '距离授权到期仅剩{day}天',
  品牌授权已过期: '品牌授权已过期',
  '品牌店铺已关注，请前往商品管理-我的收藏中查看':
    '品牌店铺已关注，请前往商品管理-我的收藏中查看',
  品牌店铺已取消关注: '品牌店铺已取消关注',
  所有商品: '所有商品',
  类目1: '类目',
  '7日上新': '7日上新',
  请输入商品名称: '请输入商品名称',
  '请前往进行品牌授权后，方可购买': '请前往进行品牌授权后，方可购买',
  新增授权任务: '新增授权任务',
  品牌信息: '品牌信息',
  品牌名称: '品牌名称',
  品牌链接: '品牌链接',
  授权条件: '授权条件',
  可授权类型: '可授权类型',
  申请授权类型: '申请授权类型',
  请选择1: '请选择',
  用途: '用途',
  销售平台: '销售平台',
  平台链接: '平台链接',
  '预计月采购额（円）': '预计月采购额（円）',
  '预计年采购额（円）': '预计年采购额（円）',
  其他补充说明: '其他补充说明',
  是否需要联名: '是否需要联名',
  联名需求描述: '联名需求描述',
  保存1: '保存',
  保存并发布: '保存并发布',
  授权条件1: '授权条件',
  提示1: '提示',
  '提交授权申请后，THE CKB工作人员会在{day}个工作日内联系您。可在工作台-品牌管理查看授权进度':
    '提交授权申请后，THE CKB工作人员会在{day}个工作日内联系您。可在工作台-品牌管理查看授权进度',
  '授权已保存，可在工作台-品牌管理查看授权进度':
    '授权已保存，可在工作台-品牌管理查看授权进度',
  前往查看: '前往查看',
  '前往查看>': '前往查看>',
  下载授权书: '下载授权书',
  优质供应商: '优质供应商',
  目录: '目录',
  供应商优势: '供应商优势',
  基础信息: '基础信息',
  热卖产品: '热卖产品',
  品牌授权书: '品牌授权书',
  品牌授权: '品牌授权',
  申请类型: '申请类型',
  申请日期: '申请日期',
  开始日期: '开始日期',
  结束日期1: '结束日期',
  新增品牌授权: '新增品牌授权',
  待提交: '待提交',
  审核中: '审核中',
  已授权3: '已授权',
  已拒绝3: '已拒绝',
  申请信息: '申请信息',
  审核信息: '审核信息',
  授权状态1: '授权状态',
  授权有效期: '授权有效期',
  重新申请: '重新申请',
  审核详情: '审核详情',
  通过: '通过',
  时间1: '时间',
  '是否确认提交？': '是否确认提交？',
  '是否确认取消？': '是否确认取消？',
  '存在部分商品未授权，请查看详情并申请授权':
    '存在部分商品未授权，请查看详情并申请授权',
  进入品牌: '进入品牌',
  联名品牌: '联名品牌',
  联名: '联名',
  不联名: '不联名',
  操作后状态: '操作后状态',
  我收藏的品牌: '我收藏的品牌',
  品牌已下架: '品牌已下架',
  前往品牌列表: '前往品牌列表',
  '前往品牌列表>': '前往品牌列表>',
  查看全部: '查看全部',
  '前往授权>': '前往授权>',
  前往授权: '前往授权',
  // 具体站点不同的说明不一样
  普通授权字段说明: '普通授权字段说明',
  // 具体站点不同的说明不一样
  独家授权字段说明: '独家授权字段说明',
  // 具体站点不同的说明不一样
  '品牌集的优势介绍 给用户带来什么': '品牌集的优势介绍 给用户带来什么',
  销售平台不能为空: '销售平台不能为空',
  联名品牌不能为空: '联名品牌不能为空',
  淘宝: '淘宝',
  直营商城: '直营商城',
  待完善: '待完善',
  '密码的新建/变更': '密码的新建/变更',
  请填写邮箱: '请填写邮箱',
  '默认物流不可发该国家，请重新选择': '默认物流不可发该国家，请重新选择',
  // $色差$:
  //  '不良原因: 有色差<br/>根据检验标准判断是不良品<br/>请决定您是否重拍',
  为不超过次品退货期限次品默认退货:
    '【※注意】为不超过次品退货期限，次品默认退货',
  专属折扣价: '专属折扣价',
  是否使用在途库存: '是否使用在途库存',
  使用1: '使用',
  '(如果您选择了「使用」，如您有处理中的库存，将会使用处理中库存进行下单(无需支付商品费用，处理中库存成品上架后即可发货))':
    '(如果您选择了「使用」，如您有处理中的库存，将会使用处理中库存进行下单(无需支付商品费用，处理中库存成品上架后即可发货))',
  不使用1: '不使用',
  '(如果您选择了「不使用」，则会为您采购成品库存不足的商品)':
    '(如果您选择了「不使用」，则会为您采购成品库存不足的商品)',
  使用在途库存: '使用在途库存',
  不使用在途库存: '不使用在途库存',
  处理中库存提醒: '处理中库存提醒',
  '以下商品有正在处理中的库存，请选择处理方式：':
    '以下商品有正在处理中的库存，请选择处理方式：',
  '不使用在途库存，直接下单重新采购': '不使用在途库存，直接下单重新采购',
  '使用处理中库存进行下单（无需支付商品费用，处理中库存成品上架后即可发货）':
    '使用处理中库存进行下单（无需支付商品费用，处理中库存成品上架后即可发货）',
  '请选择是否使用在途库存进行下单处理方式：':
    '请选择是否使用在途库存进行下单处理方式：',
  批量优先发货: '批量优先发货',
  请将优先发货筛选项改为是后操作: '请将优先发货筛选项改为是后操作',
  请将优先发货筛选项改为是后操作1: '请将优先发货筛选项改为是后操作',
  '批量优先发货中，请稍等1-3分钟，期间请勿重复操作':
    '批量优先发货中，请稍等1-3分钟，期间请勿重复操作',
  在途: '在途',
  在途抵用: '在途抵用',
  等待采购: '等待采购',
  采购处理中: '采购处理中',
  采购完成: '采购完成',
  国内运输中1: '国内运输中',
  已入库1: '已入库',
  质检中1: '质检中',
  异常处理中: '异常处理中',
  //   取消: '取消',
  同意1: '同意',
  购买数: '购买数',
  处理中库存使用数: '处理中库存使用数',
  是否确认批量优先发货: '是否确认批量优先发货',
  '※処理中＝ 国内運送中＋入庫済み＋検品中':
    '处理中＝国内运输中＋已入库＋检品中',
  已经存在提前发货任务: '已经存在提前发货任务',
  order_直行便SKU: 'THE CKB SKU',
  选择订单数: '选择订单数',
  确认分纳发送吗: '确认分纳发送吗',
  发送确认: '发送确认',
  // sku一对多翻译
  '关联商品可以支持(1对多)的绑定啦！': '关联商品可以支持(1对多)的绑定啦！',
  供货商品数: '供货商品数',
  api商品: '商品',
  选择已同步商品: '选择已同步商品',
  选择外部销售商品: '选择外部销售商品',
  选择供货商品: '选择供货商品',
  选择关联的规格: '选择关联的规格',
  保存即关联成功: '保存即关联成功',
  销售商品: '销售商品',
  请输入商品名2: '请输入商品名',
  '当前店铺未绑定API，授权后可绑定商品，享受自动下单功能':
    '当前店铺未绑定API，授权后可绑定商品，享受自动下单功能',
  请先去授权: '请先去授权',
  '当前店铺已绑定API，去选择要绑定的商品':
    '当前店铺已绑定API，去选择要绑定的商品',
  选择销售商品: '选择销售商品',
  重置2: '重置',
  选择2: '选择',
  绑定中: '绑定中',
  供货商品: '供货商品',
  '选择OEM、组合商品': '选择OEM、组合商品',
  '绑定成功后，多个供货商品之间的库存可共用！下单时会按照顺位进行依次扣除':
    '绑定成功后，多个供货商品之间的库存可共用！下单时会按照顺位进行依次扣除',
  '请输入URL、商品名、THE CKB SKU': '请输入URL、商品名、THE CKB SKU',
  主2: '主',
  商品: '商品',
  '所有供货商品库存不足时，将会采购主商品':
    '所有供货商品库存不足时，将会采购主商品',
  次: '次',
  '第{num}顺位商品': '第{num}顺位商品',
  设为主商品: '设为主商品',
  规格2: '规格',
  去选择要绑定的供货商品: '去选择要绑定的供货商品',
  '可支持绑定多个商品，建议前往绑定库存商品':
    '可支持绑定多个商品，建议前往绑定库存商品',
  库存商品: '库存商品',
  是否确认删除2: '是否确认删除',
  删除后将自动解绑该商品下已绑定的SKU: '删除后将自动解绑该商品下已绑定的SKU',
  绑定成功2: '绑定成功',
  '抱歉，绑定失败': '抱歉，绑定失败',
  '原因：该商品已被其他销售商品绑定，需要先解绑后才能绑定该商品。':
    '原因：该商品已被其他销售商品绑定，需要先解绑后才能绑定该商品。 ',
  当前被该商品绑定: '当前被该商品绑定',
  解绑并绑定到当前商品上: '解绑并绑定到当前商品上',
  最多只能绑定3个商品: '最多只能绑定3个商品',
  最多只能绑定30个商品: '最多只能绑定30个商品',
  供货商品库存: '供货商品库存',
  销售商品库存: '销售商品库存',
  '当前售卖商品库存为关联的所有供货商品的库存总和，以便您进行销售库存的预估和管理':
    '当前售卖商品库存为关联的所有供货商品的库存总和，以便您进行销售库存的预估和管理',
  销售sku: '销售sku',
  去绑定: '去绑定',
  修改绑定: '修改绑定',
  当前商品绑定关系: '当前商品绑定关系',
  '当前商品未绑定Amazon sku，请在下方搜索进行绑定':
    '当前商品未绑定Amazon sku，请在下方搜索进行绑定',
  平台2: '平台',
  '请输入要绑定的Amazon sku': '请输入要绑定的Amazon sku',
  '已绑定Amazon sku': '已绑定Amazon sku',
  查看商品绑定关系: '查看商品绑定关系',
  我知道了3: '我知道了',
  '当所有供货商品库存不足，将会采购主商品':
    '当所有供货商品库存不足，将会采购主商品',
  是否设为主商品: '是否设为主商品',
  是否解绑: '是否解绑',
  编号: 'sku',
  '当前店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能':
    '当前店铺未授权同步数据功能，授权后可绑定商品，享受自动下单功能',
  '当前店铺已授权同步数据功能，去选择要绑定的商品':
    '当前店铺已授权同步数据功能，去选择要绑定的商品',
  去选择: '去选择',
  去选择2: '去选择',
  去选择3: '去选择',
  '请点击“同步商品”': '请点击“同步商品”',
  '可支持绑定多个商品，前往去绑定库存商品':
    '可支持绑定多个商品，前往去绑定库存商品',
  '暂无商品，请先去搜索商品': '暂无商品，请先去搜索商品',
  '当前商品未绑定Amazon sku,请在下方搜索Amazon sku进行绑定':
    '当前商品未绑定Amazon sku,请在下方搜索Amazon sku进行绑定',
  当前sku已绑定: '当前sku已绑定',
  是否解除绑定: '是否解除绑定',
  三方商品关联不允许多对多: '三方商品关联不允许多对多',
  黑名单商品不允许关联商品: '黑名单商品不允许关联商品',
  '该商品不在该店铺内，请重新操作': '该商品不在该店铺内，请重新操作',
  '{price}元/点/日': '{price}元/点/日 ',
  自建独立站: '自建独立站',
  '补充手机号，获得担当优先服务!': '补充手机号，获得担当优先服务!',
  立即填写: '立即填写',
  主账号余额: '主账号余额',
  主账号余额1: '利用可能額',
  消息通知: '消息通知',
  立即处理: '立即处理',
  API自动下单异常: 'API自动下单异常',
  待支付账单: '待支付账单',
  OEM待确认报价: 'OEM待确认报价',
  常用功能: '常用功能',
  全部功能: '全部功能',
  自定义常用功能: '自定义常用功能',
  'X个包裹因欠费而无法发货，请尽快充值': 'X个包裹因欠费而无法发货，请尽快充值',
  '有包裹因欠费而无法发货，请尽快转账': '有包裹因欠费而无法发货，请尽快转账',
  待处理异常订单: '待处理异常订单',
  组合商品落单: '组合商品落单',
  重要公告: '重要公告',
  热门活动: '热门活动',
  功能更新: '功能更新',
  暂无公告: '暂无公告',
  会员自动续费: '会员自动续费',
  '条(未读)': '条(未读)',
  请添加常用功能: '请添加常用功能',
  最多添加5个常用功能: '最多添加5个常用功能',
  在库商品: '在库商品',
  当前店铺: '当前店铺',
  'Paypal入金后，如果返金情况，手续费扣除不能返还': 'Paypal入金后，如果返金情况，手续费扣除不能返还',
  修改手机号: '修改手机号',
  注意4: '注意',
  重新上传: '重新上传',
  继续上传: '继续上传',
  重复信息: '重复信息',
  行目: '行目',
  '请确认重复信息，若确认请点击继续上传，否则请重新上传修改后的文件。': '请确认重复信息，若确认请点击继续上传，否则请重新上传修改后的文件。',
  存在重复的乐天SKU: '存在重复的乐天SKU',
  存在重复JANcode: '存在重复JANcode',
  存在重复商品SKU: '存在重复商品SKU',
  去原网站选品2: '去原网站选品',
  去原网站选品: '去原网站选品',
  发货仓库2: '发货仓库',
  待采购2: '待采购',
  已采购2: '已采购',
  组合商品2: '组合商品',
  // sku一对多翻译
  // 为了防止冲突，最后一行不要修改，添加的翻译写在之上
  $最后一行谢谢$: ''
}
